/* eslint-disable */

/* THIS FILE IS AUTOGENERATED. */


export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  CMS_SSR_Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  CMS_SSR_DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  CMS_SSR_Decimal: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  CMS_SSR_JSONString: any;
  /** GraphQL type for an integer that must be equal or greater than zero. */
  CMS_SSR_PositiveInt: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  CMS_SSR_UUID: any;
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: Record<string, unknown>;
};

export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type CMS_SSR = {
  __typename: 'CMS_SSR';
  activeLicenceTypes: Array<CMS_SSR_LicenceTypeInterface>;
  awards: Array<CMS_SSR_AwardInterface>;
  bigSpecimenSet: Maybe<CMS_SSR_BigSpecimenSet>;
  blogCategories: Array<CMS_SSR_BlogTagInterface>;
  blogPost: Maybe<CMS_SSR_BlogPage>;
  blogPosts: Maybe<Array<CMS_SSR_BlogPage>>;
  collections: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  config: CMS_SSR_ConfigInterface;
  customFont: Maybe<CMS_SSR_CustomFontInterface>;
  customFonts: Array<CMS_SSR_CustomFontInterface>;
  debug: Maybe<CMS_SSR_DjangoDebug>;
  document: Maybe<CMS_SSR_DocumentObjectType>;
  documentType: Scalars['String'];
  documents: Array<CMS_SSR_DocumentObjectType>;
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontFamily: Maybe<CMS_SSR_FontFamilyInterface>;
  fontFamilyGroup: Maybe<CMS_SSR_FontFamilyGroupInterface>;
  fontFamilyGroups: Array<CMS_SSR_FontFamilyGroupInterface>;
  homepage: CMS_SSR_HomePage;
  image: Maybe<CMS_SSR_CustomImage>;
  imageType: Scalars['String'];
  images: Array<CMS_SSR_CustomImage>;
  inUseCategories: Array<CMS_SSR_TagInterface>;
  inUsePost: Maybe<CMS_SSR_FontsInUseDetailPage>;
  inUsePosts: Maybe<Array<CMS_SSR_FontsInUseDetailPage>>;
  mediumSpecimenSet: Maybe<CMS_SSR_MediumSpecimenSet>;
  page: Maybe<CMS_SSR_PageInterface>;
  pages: Array<CMS_SSR_PageInterface>;
  previewSpecimenSet: Maybe<CMS_SSR_PreviewSpecimenSet>;
  redirects: Array<CMS_SSR_Redirect>;
  search: Array<CMS_SSR_Search>;
  site: Maybe<CMS_SSR_SiteObjectType>;
  sites: Array<CMS_SSR_SiteObjectType>;
  smallSpecimenSet: Maybe<CMS_SSR_SmallSpecimenSet>;
  snippets: Array<CMS_SSR_SnippetInterface>;
  tag: Maybe<CMS_SSR_TagObjectType>;
  tags: Array<CMS_SSR_TagObjectType>;
  testFonts: CMS_SSR_TestFontsInterface;
};


export type CMS_SSRbigSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRblogPostArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRblogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRcollectionsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRcustomFontArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRdocumentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRdocumentsArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRfontFamilyArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRfontFamilyGroupArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRhomepageArgs = {
  order?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRimageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRimagesArgs = {
  collection?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRinUsePostArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRinUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRmediumSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRpageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRpagesArgs = {
  ancestor?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  inSite?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRpreviewSpecimenSetArgs = {
  fontFamily: Scalars['ID'];
  specimenConfig: Scalars['ID'];
};


export type CMS_SSRsearchArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRsiteArgs = {
  hostname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRsitesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  isDefaultSite?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSRsmallSpecimenSetArgs = {
  contentAmount: Scalars['Int'];
  fontFamily: Scalars['ID'];
};


export type CMS_SSRtagArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type CMS_SSRtagsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_AccountInterface = {
  __typename: 'CMS_SSR_AccountInterface';
  id: Scalars['ID'];
  user: CMS_SSR_UserInterface;
};

export type CMS_SSR_AwardInterface = {
  __typename: 'CMS_SSR_AwardInterface';
  customFonts: Array<CMS_SSR_CustomFontInterface>;
  /** Projects where Klim’s contribution was significant and/or essential. */
  essentialContribution: Scalars['Boolean'];
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontFamilyGroups: Array<CMS_SSR_FontFamilyGroupInterface>;
  id: Scalars['ID'];
  /** The HTML tag <ordn>th</ordn> can be used to apply ordinals. */
  name: Scalars['String'];
  /** Can be left empty as long as at least one font family group or font family or custom font is selected below. */
  receivedFor: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  year: Scalars['Int'];
};

export type CMS_SSR_BigSpecimenSet = {
  __typename: 'CMS_SSR_BigSpecimenSet';
  fontSize: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithWords>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  referenceWordCalculatedWidth: Scalars['Int'];
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
};

export type CMS_SSR_BlockQuoteBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_BlockQuoteBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_BlogIndexPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_BlogIndexPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_BlogIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_BlogPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_BlogPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  author: Maybe<Scalars['String']>;
  blurb: Maybe<Scalars['String']>;
  blurbImage: CMS_SSR_CustomImage;
  body: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  categories: Array<CMS_SSR_BlogTag>;
  children: Array<CMS_SSR_PageInterface>;
  colorHighlight: Scalars['String'];
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CMS_SSR_CustomImage>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontFamilyGroups: Maybe<Array<CMS_SSR_FontFamilyGroupInterface>>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  hero: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  id: Maybe<Scalars['ID']>;
  intro: Maybe<Scalars['String']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['CMS_SSR_DateTime'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  relatedBlogPosts: Array<CMS_SSR_BlogPage>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_BlogPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagerelatedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_BlogPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_BlogPostFeaturedFont = {
  __typename: 'CMS_SSR_BlogPostFeaturedFont';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_BlogTag = {
  __typename: 'CMS_SSR_BlogTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type CMS_SSR_BlogTagInterface = {
  __typename: 'CMS_SSR_BlogTagInterface';
  blogTaggedblogbaseItems: Array<CMS_SSR_TaggedBlogBase>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CMS_SSR_BooleanBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_BooleanBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Boolean'];
};

export type CMS_SSR_CampaignCodeInterface = {
  __typename: 'CMS_SSR_CampaignCodeInterface';
  /** The live code animation to run. Animations are written by developers and added to the website code. */
  animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices;
  created: Scalars['CMS_SSR_DateTime'];
  id: Scalars['ID'];
  layoutModeLandscape: CMS_SSR_CampaignLayoutMode;
  layoutModePortrait: CMS_SSR_CampaignLayoutMode;
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapLandscape: Scalars['Int'];
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  options: Scalars['CMS_SSR_JSONString'];
};

export type CMS_SSR_CampaignImageInterface = {
  __typename: 'CMS_SSR_CampaignImageInterface';
  /** Background colour */
  colorBackground: Maybe<Scalars['String']>;
  created: Scalars['CMS_SSR_DateTime'];
  id: Scalars['ID'];
  /** An image of at least 4000px wide, ideally. Or an SVG. */
  imageLandscape: Scalars['String'];
  imageLandscapeHeight: Scalars['Int'];
  imageLandscapeWidth: Scalars['Int'];
  /** An alternate portrait image of at least 4000px high, ideally. Or an SVG. */
  imagePortrait: Maybe<Scalars['String']>;
  imagePortraitHeight: Maybe<Scalars['Int']>;
  imagePortraitWidth: Maybe<Scalars['Int']>;
  layoutModeLandscape: CMS_SSR_CampaignLayoutMode;
  layoutModePortrait: CMS_SSR_CampaignLayoutMode;
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapLandscape: Scalars['Int'];
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  sortOrder: Scalars['Int'];
};

export type CMS_SSR_CampaignInterface = {
  __typename: 'CMS_SSR_CampaignInterface';
  codes: Array<CMS_SSR_CampaignCodeInterface>;
  created: Scalars['CMS_SSR_DateTime'];
  displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices;
  fontfamilySet: Array<CMS_SSR_FontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CMS_SSR_CampaignImageInterface>;
  modified: Scalars['CMS_SSR_DateTime'];
  /** When enabled, any heading SVG will show overlaid on top of the campaign media, as opposed to below it. */
  svgHeadingOverlay: Scalars['Boolean'];
  /** In milliseconds. */
  transitionDuration: Scalars['Int'];
  /** In milliseconds. Time between transitions. */
  transitionInterval: Scalars['Int'];
  type: CMS_SSR_CampaignsCampaignTypeChoices;
  videos: Array<CMS_SSR_CampaignVideoInterface>;
};

/** Campaign layout mode */
export enum CMS_SSR_CampaignLayoutMode {
  FULL_WIDTH = 'FULL_WIDTH',
  WITHIN_GRID = 'WITHIN_GRID'
}

export type CMS_SSR_CampaignVideoInterface = {
  __typename: 'CMS_SSR_CampaignVideoInterface';
  created: Scalars['CMS_SSR_DateTime'];
  id: Scalars['ID'];
  layoutModeLandscape: CMS_SSR_CampaignLayoutMode;
  layoutModePortrait: CMS_SSR_CampaignLayoutMode;
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapLandscape: Scalars['Int'];
  /** Will expand media outwards into the margins by this percentage. Can be used to align fuzzy edges of the media to the sharp typography on the page. */
  marginOverlapPortrait: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  videoLandscape: CMS_SSR_VimeoVideoInterface;
  videoPortrait: Maybe<CMS_SSR_VimeoVideoInterface>;
};

/** An enumeration. */
export enum CMS_SSR_CampaignsCampaignCodeAnimationChoices {
  /** Geograph contours: New Zealand */
  GEOGRAPH_CONTOURS_NZ = 'GEOGRAPH_CONTOURS_NZ'
}

/** An enumeration. */
export enum CMS_SSR_CampaignsCampaignDisplayModeChoices {
  /** Cross-fade (as ordered) */
  CROSS_FADE = 'CROSS_FADE',
  /** Cross-fade (random order) */
  CROSS_FADE_RANDOM = 'CROSS_FADE_RANDOM',
  /** Random image or video on load */
  RANDOM_SINGLE = 'RANDOM_SINGLE'
}

/** An enumeration. */
export enum CMS_SSR_CampaignsCampaignTypeChoices {
  /** Live code */
  CODE = 'CODE',
  /** Image */
  IMAGE = 'IMAGE',
  /** Video */
  VIDEO = 'VIDEO'
}

export type CMS_SSR_CartInterface = {
  __typename: 'CMS_SSR_CartInterface';
  /** Subtotal, expressed in the cart base currency */
  amountSubtotal: Scalars['Float'];
  /** Subtotal, expressed in cart currency */
  amountSubtotalConverted: Scalars['Float'];
  /** Subtotal of all fonts with licence multipliers, expressed in the cart base currency */
  amountSubtotalForFontsWithLicenceMultiplier: Scalars['Float'];
  /** Tax in cart final currency */
  amountTax: Scalars['Float'];
  /** Tax in USD */
  amountTaxUsd: Scalars['Float'];
  /** Total in cart currency */
  amountTotal: Scalars['Float'];
  /** Total in USD */
  amountTotalUsd: Scalars['Float'];
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CMS_SSR_CountryChoices>;
  /** Person to direct the invoice to */
  billingName: Maybe<Scalars['String']>;
  billingPostcode: Maybe<Scalars['String']>;
  /** Optional P/O to be specified on the invoice. */
  billingPurchaseOrder: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  /** Optional VAT number to be specified on the invoice. */
  billingVatNumber: Maybe<Scalars['String']>;
  currency: Maybe<CMS_SSR_CurrencyChoices>;
  discounts: Array<CMS_SSR_DiscountInterface>;
  emailOptIn: Scalars['Boolean'];
  exchangeRate: Scalars['Float'];
  hasDownloadables: Scalars['Boolean'];
  hasFontlessItems: Scalars['Boolean'];
  hasSimpleLicensing: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceExtraDescription: Maybe<Scalars['String']>;
  invoiceId: Maybe<Scalars['ID']>;
  invoiceNumber: Maybe<Scalars['String']>;
  /** Lets us know whether the cart is for a Quote or Invoice */
  isInvoice: Scalars['Boolean'];
  items: Array<CMS_SSR_LineItemInterface>;
  /** Legacy field, for reference only. */
  legacyBillingAddress: Maybe<Scalars['String']>;
  /** Legacy field, for reference only. */
  legacyLicensedTo: Maybe<Scalars['String']>;
  licenceTiers: Array<CMS_SSR_CartTierInterface>;
  /** When checked the licensee of the purchase can be specified in the "Licensee" fields. If not checked the billing details will determine the licensee. */
  licensedForSomeoneElse: Scalars['Boolean'];
  licensedToAddress1: Maybe<Scalars['String']>;
  licensedToAddress2: Maybe<Scalars['String']>;
  licensedToCity: Maybe<Scalars['String']>;
  licensedToCompanyName: Maybe<Scalars['String']>;
  licensedToCountry: Maybe<CMS_SSR_CountryChoices>;
  licensedToPostcode: Maybe<Scalars['String']>;
  licensedToState: Maybe<Scalars['String']>;
  licensedToVatNumber: Maybe<Scalars['String']>;
  nativeCurrency: Maybe<CMS_SSR_CurrencyChoices>;
  refundedAmount: Scalars['Float'];
  taxRate: Scalars['Float'];
  userEmail: Maybe<Scalars['String']>;
  /** Inverse of usesNativeCurrency. */
  usesCurrencyConversion: Scalars['Boolean'];
  /** Whether the amounts in this cart are expressed in the native currency (e.g. GBP) or, if not, then they are expressed in USD and the final total is converted to e.g. GBP. */
  usesNativeCurrency: Scalars['Boolean'];
};

export type CMS_SSR_CartTierInterface = {
  __typename: 'CMS_SSR_CartTierInterface';
  /** The filename of the licence contract pertaining to this licence type for this sale. */
  contractDetails: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** For Web this is the domain name, for App this is the app name. */
  licenceSubject: Maybe<Scalars['String']>;
  tier: CMS_SSR_TierInterface;
};

export type CMS_SSR_CharBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_CharBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_ChoiceBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ChoiceBlock';
  blockType: Scalars['String'];
  choices: Array<CMS_SSR_ChoiceOption>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_ChoiceOption = {
  __typename: 'CMS_SSR_ChoiceOption';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Collection type */
export type CMS_SSR_CollectionObjectType = {
  __typename: 'CMS_SSR_CollectionObjectType';
  ancestors: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  depth: Scalars['Int'];
  descendants: Array<Maybe<CMS_SSR_CollectionObjectType>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numchild: Scalars['Int'];
  path: Scalars['String'];
};

export type CMS_SSR_ColorSchemeInterface = {
  __typename: 'CMS_SSR_ColorSchemeInterface';
  colorBackground: Scalars['String'];
  colorBackgroundAlt: Maybe<Scalars['String']>;
  colorForeground: Scalars['String'];
  colorForegroundAlt: Maybe<Scalars['String']>;
  colorHighlight: Scalars['String'];
  colorHighlightAlt: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CMS_SSR_ConfigInterface = {
  __typename: 'CMS_SSR_ConfigInterface';
  awardPageIntro: Scalars['String'];
  /** Base currency for all pricing on the site. */
  baseCurrency: CMS_SSR_CurrencyChoices;
  bigSpecimenRefFontSizePx: Scalars['Int'];
  /** UTC datetime of the static build of the website. */
  buildDateTime: Scalars['CMS_SSR_DateTime'];
  /** Klim’s official business name. */
  businessName: Scalars['String'];
  /** Klim’s official site URL. */
  businessUrl: Scalars['String'];
  /** All valid country choices. */
  countries: Array<CMS_SSR_CountryInterface>;
  /** Discount applied to the lowest priced FontStyle(s) when buying the same FontStyles for different licence types */
  crossLicenceDiscountPercentage: Scalars['Float'];
  /** A list of custom tag names that may be present in Wagtail rich text and need to be substituted with proper CSS. */
  customOpentypeHtmlTagNames: Array<Scalars['String']>;
  /** Klim’s support email address. */
  emailSupport: Scalars['String'];
  /** All available Klim EULA texts. */
  eulas: Array<CMS_SSR_EulaInterface>;
  isProductionSite: Scalars['Boolean'];
  languages: Array<CMS_SSR_LanguageInterface>;
  licenceTypeShortNames: Array<CMS_SSR_LicenceTypeShortName>;
  openTypeFeatureMetaData: Array<CMS_SSR_OpenTypeFeatureMetaDataInterface>;
  /** Package discount percentages, keyed on fontType. */
  packageDiscountPercentages: Array<CMS_SSR_PackageDiscountPercentage>;
  /** Font style quantity discount percentages, when buying the same licence type within the same FontFamily. */
  styleDiscountPercentages: Array<CMS_SSR_StyleDiscountPercentage>;
  /** The unit price for a FontStyle. */
  unitPriceFontStyle: Scalars['Float'];
  userTestingCheckoutAllowed: Scalars['Boolean'];
  userTestingFontFamilyGroupWhitelist: Array<CMS_SSR_FontFamilyGroupInterface>;
  userTestingHostname: Maybe<Scalars['String']>;
};

export type CMS_SSR_ContentWithFootNotesBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ContentWithFootNotesBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  content: Scalars['String'];
  field: Scalars['String'];
  footNotes: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

/** An enumeration. */
export enum CMS_SSR_CountryChoices {
  /** Ascension Island */
  AC = 'AC',
  /** Andorra */
  AD = 'AD',
  /** United Arab Emirates */
  AE = 'AE',
  /** Afghanistan */
  AF = 'AF',
  /** Antigua and Barbuda */
  AG = 'AG',
  /** Anguilla */
  AI = 'AI',
  /** Albania */
  AL = 'AL',
  /** Armenia */
  AM = 'AM',
  /** Angola */
  AO = 'AO',
  /** Antarctica */
  AQ = 'AQ',
  /** Argentina */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Austria */
  AT = 'AT',
  /** Australia */
  AU = 'AU',
  /** Aruba */
  AW = 'AW',
  /** Finland (Åland Islands) */
  AX = 'AX',
  /** Azerbaijan */
  AZ = 'AZ',
  /** Bosnia and Herzegovina */
  BA = 'BA',
  /** Barbados */
  BB = 'BB',
  /** Bangladesh */
  BD = 'BD',
  /** Belgium */
  BE = 'BE',
  /** Burkina Faso */
  BF = 'BF',
  /** Bulgaria (Republic) */
  BG = 'BG',
  /** Bahrain */
  BH = 'BH',
  /** Burundi */
  BI = 'BI',
  /** Benin */
  BJ = 'BJ',
  /** Saint Barthelemy */
  BL = 'BL',
  /** Bermuda */
  BM = 'BM',
  /** Brunei Darussalam */
  BN = 'BN',
  /** Bolivia */
  BO = 'BO',
  /** Bonaire, Sint Eustatius, and Saba */
  BQ = 'BQ',
  /** Brazil */
  BR = 'BR',
  /** Bahamas */
  BS = 'BS',
  /** Bhutan */
  BT = 'BT',
  /** Bouvet Island */
  BV = 'BV',
  /** Botswana */
  BW = 'BW',
  /** Belarus */
  BY = 'BY',
  /** Belize */
  BZ = 'BZ',
  /** Canada */
  CA = 'CA',
  /** Cocos (Keeling) Islands */
  CC = 'CC',
  /** Congo (Dem. Republic) */
  CD = 'CD',
  /** Central African Republic */
  CF = 'CF',
  /** Congo (Republic) */
  CG = 'CG',
  /** Switzerland */
  CH = 'CH',
  /** Cote D’Ivoire */
  CI = 'CI',
  /** Cook Islands */
  CK = 'CK',
  /** Chile */
  CL = 'CL',
  /** Cameroon */
  CM = 'CM',
  /** China */
  CN = 'CN',
  /** Colombia */
  CO = 'CO',
  /** Costa Rica */
  CR = 'CR',
  /** Cuba */
  CU = 'CU',
  /** Cape Verde */
  CV = 'CV',
  /** Curaçao */
  CW = 'CW',
  /** Christmas Island */
  CX = 'CX',
  /** Cyprus */
  CY = 'CY',
  /** Czech Republic */
  CZ = 'CZ',
  /** Germany */
  DE = 'DE',
  /** Djibouti */
  DJ = 'DJ',
  /** Denmark */
  DK = 'DK',
  /** Dominica */
  DM = 'DM',
  /** Dominican Republic */
  DO = 'DO',
  /** Algeria */
  DZ = 'DZ',
  /** Ecuador */
  EC = 'EC',
  /** Estonia */
  EE = 'EE',
  /** Egypt */
  EG = 'EG',
  /** Western Sahara */
  EH = 'EH',
  /** Eritrea */
  ER = 'ER',
  /** Spain */
  ES = 'ES',
  /** Ethiopia */
  ET = 'ET',
  /** Finland */
  FI = 'FI',
  /** Fiji */
  FJ = 'FJ',
  /** Falkland Islands (Malvinas) */
  FK = 'FK',
  /** Micronesia (Federated State of) */
  FM = 'FM',
  /** Faroe Islands */
  FO = 'FO',
  /** France */
  FR = 'FR',
  /** Gabon */
  GA = 'GA',
  /** United Kingdom */
  GB = 'GB',
  /** Grenada (West Indies) */
  GD = 'GD',
  /** Georgia */
  GE = 'GE',
  /** French Guiana */
  GF = 'GF',
  /** Channel Islands (Guernsey) */
  GG = 'GG',
  /** Ghana */
  GH = 'GH',
  /** Gibraltar */
  GI = 'GI',
  /** Greenland */
  GL = 'GL',
  /** Gambia */
  GM = 'GM',
  /** Guinea */
  GN = 'GN',
  /** Guadeloupe */
  GP = 'GP',
  /** Equatorial Guinea */
  GQ = 'GQ',
  /** Greece */
  GR = 'GR',
  /** South Georgia */
  GS = 'GS',
  /** Guatemala */
  GT = 'GT',
  /** Guam */
  GU = 'GU',
  /** Guinea-Bissau */
  GW = 'GW',
  /** Guyana */
  GY = 'GY',
  /** Hong Kong */
  HK = 'HK',
  /** Heard and McDonald Islands */
  HM = 'HM',
  /** Honduras */
  HN = 'HN',
  /** Croatia */
  HR = 'HR',
  /** Haiti */
  HT = 'HT',
  /** Hungary (Republic) */
  HU = 'HU',
  /** Indonesia */
  ID = 'ID',
  /** Ireland */
  IE = 'IE',
  /** Israel */
  IL = 'IL',
  /** Isle of Man */
  IM = 'IM',
  /** India */
  IN = 'IN',
  /** British Indian Ocean Territory */
  IO = 'IO',
  /** Iraq */
  IQ = 'IQ',
  /** Iran */
  IR = 'IR',
  /** Iceland */
  IS = 'IS',
  /** Italy */
  IT = 'IT',
  /** Channel Islands (Jersey) */
  JE = 'JE',
  /** Jamaica */
  JM = 'JM',
  /** Jordan */
  JO = 'JO',
  /** Japan */
  JP = 'JP',
  /** Kenya */
  KE = 'KE',
  /** Kyrgyzstan */
  KG = 'KG',
  /** Cambodia */
  KH = 'KH',
  /** Kiribati */
  KI = 'KI',
  /** Comoros */
  KM = 'KM',
  /** Saint Kitts and Nevis */
  KN = 'KN',
  /** North Korea */
  KP = 'KP',
  /** South Korea */
  KR = 'KR',
  /** Kuwait */
  KW = 'KW',
  /** Cayman Islands */
  KY = 'KY',
  /** Kazakhstan */
  KZ = 'KZ',
  /** Lao (People’s Dem. Republic) */
  LA = 'LA',
  /** Lebanon */
  LB = 'LB',
  /** Saint Lucia */
  LC = 'LC',
  /** Liechtenstein */
  LI = 'LI',
  /** Sri Lanka */
  LK = 'LK',
  /** Liberia */
  LR = 'LR',
  /** Lesotho */
  LS = 'LS',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Latvia */
  LV = 'LV',
  /** Libya */
  LY = 'LY',
  /** Morocco */
  MA = 'MA',
  /** Monaco */
  MC = 'MC',
  /** Moldova (Republic) */
  MD = 'MD',
  /** Montenegro */
  ME = 'ME',
  /** Saint Martin */
  MF = 'MF',
  /** Madagascar */
  MG = 'MG',
  /** Marshall Islands */
  MH = 'MH',
  /** Macedonia */
  MK = 'MK',
  /** Mali */
  ML = 'ML',
  /** Myanmar */
  MM = 'MM',
  /** Mongolia */
  MN = 'MN',
  /** Macao */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Martinique */
  MQ = 'MQ',
  /** Mauritania */
  MR = 'MR',
  /** Montserrat */
  MS = 'MS',
  /** Malta */
  MT = 'MT',
  /** Mauritius */
  MU = 'MU',
  /** Maldives */
  MV = 'MV',
  /** Malawi */
  MW = 'MW',
  /** Mexico */
  MX = 'MX',
  /** Malaysia */
  MY = 'MY',
  /** Mozambique */
  MZ = 'MZ',
  /** Namibia */
  NA = 'NA',
  /** New Caledonia */
  NC = 'NC',
  /** Niger */
  NE = 'NE',
  /** Norfolk Island */
  NF = 'NF',
  /** Nigeria */
  NG = 'NG',
  /** Nicaragua */
  NI = 'NI',
  /** The Netherlands */
  NL = 'NL',
  /** Norway */
  NO = 'NO',
  /** Nepal */
  NP = 'NP',
  /** Nauru Central Pacific */
  NR = 'NR',
  /** Niue */
  NU = 'NU',
  /** New Zealand */
  NZ = 'NZ',
  /** Oman */
  OM = 'OM',
  /** Panama (Republic) */
  PA = 'PA',
  /** Peru */
  PE = 'PE',
  /** French Polynesia */
  PF = 'PF',
  /** Papua New Guinea */
  PG = 'PG',
  /** Philippines */
  PH = 'PH',
  /** Pakistan */
  PK = 'PK',
  /** Poland */
  PL = 'PL',
  /** St. Pierre and Miquelon */
  PM = 'PM',
  /** Pitcairn */
  PN = 'PN',
  /** Puerto Rico */
  PR = 'PR',
  /** Palestinian Territory */
  PS = 'PS',
  /** Portugal */
  PT = 'PT',
  /** Palau */
  PW = 'PW',
  /** Paraguay */
  PY = 'PY',
  /** Qatar */
  QA = 'QA',
  /** Reunion */
  RE = 'RE',
  /** Romania */
  RO = 'RO',
  /** Serbia (Republic) */
  RS = 'RS',
  /** Russian Federation */
  RU = 'RU',
  /** Rwanda */
  RW = 'RW',
  /** Saudi Arabia */
  SA = 'SA',
  /** Solomon Islands */
  SB = 'SB',
  /** Seychelles */
  SC = 'SC',
  /** Sudan */
  SD = 'SD',
  /** Sweden */
  SE = 'SE',
  /** Singapore (Republic) */
  SG = 'SG',
  /** Saint Helena */
  SH = 'SH',
  /** Slovenia */
  SI = 'SI',
  /** Svalbard and Jan Mayen Islands */
  SJ = 'SJ',
  /** Slovakia */
  SK = 'SK',
  /** Sierra Leone */
  SL = 'SL',
  /** San Marino */
  SM = 'SM',
  /** Senegal */
  SN = 'SN',
  /** Somalia */
  SO = 'SO',
  /** Suriname */
  SR = 'SR',
  /** South Sudan */
  SS = 'SS',
  /** Sao Tome and Principe */
  ST = 'ST',
  /** El Salvador */
  SV = 'SV',
  /** Sint Maarten */
  SX = 'SX',
  /** Syria */
  SY = 'SY',
  /** Swaziland */
  SZ = 'SZ',
  /** Tristan Da Cunha */
  TA = 'TA',
  /** Turks and Caicos Islands */
  TC = 'TC',
  /** Chad */
  TD = 'TD',
  /** French Southern Territories */
  TF = 'TF',
  /** Togo */
  TG = 'TG',
  /** Thailand */
  TH = 'TH',
  /** Tajikistan */
  TJ = 'TJ',
  /** Tokelau */
  TK = 'TK',
  /** Timor-Leste */
  TL = 'TL',
  /** Turkmenistan */
  TM = 'TM',
  /** Tunisia */
  TN = 'TN',
  /** Tonga */
  TO = 'TO',
  /** Turkey */
  TR = 'TR',
  /** Trinidad and Tobago */
  TT = 'TT',
  /** Tuvalu */
  TV = 'TV',
  /** Taiwan */
  TW = 'TW',
  /** Tanzania (United Republic) */
  TZ = 'TZ',
  /** Ukraine */
  UA = 'UA',
  /** Uganda */
  UG = 'UG',
  /** United States Minor Outlying Islands */
  UM = 'UM',
  /** United States */
  US = 'US',
  /** Uruguay */
  UY = 'UY',
  /** Uzbekistan */
  UZ = 'UZ',
  /** Vatican */
  VA = 'VA',
  /** Saint Vincent and the Grenadines (Antilles) */
  VC = 'VC',
  /** Venezuela */
  VE = 'VE',
  /** Virgin Islands (British) */
  VG = 'VG',
  /** Virgin Islands (U.S.) */
  VI = 'VI',
  /** Vietnam */
  VN = 'VN',
  /** Vanuatu */
  VU = 'VU',
  /** Wallis and Futuna Islands */
  WF = 'WF',
  /** Samoa */
  WS = 'WS',
  /** Kosovo */
  XK = 'XK',
  /** Yemen */
  YE = 'YE',
  /** Mayotte */
  YT = 'YT',
  /** South Africa */
  ZA = 'ZA',
  /** Zambia */
  ZM = 'ZM',
  /** Zimbabwe */
  ZW = 'ZW'
}

export type CMS_SSR_CountryInterface = {
  __typename: 'CMS_SSR_CountryInterface';
  code: CMS_SSR_CountryChoices;
  name: Scalars['String'];
  taxId: Maybe<Scalars['String']>;
};

/** Represents information needed to render a particular style in CSS. */
export type CMS_SSR_CssRenderInfo = {
  __typename: 'CMS_SSR_CssRenderInfo';
  fontFamilyName: Scalars['String'];
  fontWeight: Maybe<Scalars['Int']>;
  isItalic: Scalars['Boolean'];
  variableAxisValues: Maybe<Array<CMS_SSR_FontVariationInstanceAxisValueInterface>>;
  woff2Path: Scalars['String'];
};

/** An enumeration. */
export enum CMS_SSR_CurrencyChoices {
  /** AUD – Australian Dollar */
  AUD = 'AUD',
  /** CAD – Canadian Dollar */
  CAD = 'CAD',
  /** CHF – Swiss Franc */
  CHF = 'CHF',
  /** CNY – Chinese Yuan */
  CNY = 'CNY',
  /** DKK – Danish Krone */
  DKK = 'DKK',
  /** EUR – Euro */
  EUR = 'EUR',
  /** GBP – Pound Sterling */
  GBP = 'GBP',
  /** JPY – Japanese Yen */
  JPY = 'JPY',
  /** NOK – Norwegian Krone */
  NOK = 'NOK',
  /** NZD – New Zealand Dollar */
  NZD = 'NZD',
  /** SEK – Swedish Krona */
  SEK = 'SEK',
  /** USD – US Dollar */
  USD = 'USD'
}

export type CMS_SSR_CustomFontFamilyInterface = {
  __typename: 'CMS_SSR_CustomFontFamilyInterface';
  id: Scalars['ID'];
  /** E.g. PayPal Sans Big or PayPal Sans Small */
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  styles: Array<CMS_SSR_CustomFontStyleInterface>;
  svg: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontImageInterface = {
  __typename: 'CMS_SSR_CustomFontImageInterface';
  /** When checked this image will be highlighted in the design */
  feature: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The higher the resolution, the better. */
  image: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type CMS_SSR_CustomFontInterface = {
  __typename: 'CMS_SSR_CustomFontInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  /** If the heading image isn't vector then a bitmap can be selected here instead. */
  bitmapHeading: Maybe<Scalars['String']>;
  colorBackground: Scalars['String'];
  colorForeground: Scalars['String'];
  colorHighlight: Scalars['String'];
  creditAgency: Array<Scalars['String']>;
  creditClient: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  /** 'Continue Reading' link of Information section */
  designInformationPage: Maybe<CMS_SSR_BlogPage>;
  families: Array<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  images: Array<CMS_SSR_CustomFontImageInterface>;
  informationIntro: Maybe<Scalars['String']>;
  isPreRelease: Scalars['Boolean'];
  name: Scalars['String'];
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  slug: Maybe<Scalars['String']>;
  specimens: Array<CMS_SSR_CustomFontSpecimenInterface>;
  styles: Array<CMS_SSR_CustomFontStyleInterface>;
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontSpecimenInterface = {
  __typename: 'CMS_SSR_CustomFontSpecimenInterface';
  /** If the image isn't vector then a bitmap can be selected here instead. */
  bitmap: Maybe<Scalars['String']>;
  family: Maybe<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  /** E.g. 'Regular' or 'Regular Italic' */
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  svg: Maybe<Scalars['String']>;
};

export type CMS_SSR_CustomFontStyleInterface = {
  __typename: 'CMS_SSR_CustomFontStyleInterface';
  family: Maybe<CMS_SSR_CustomFontFamilyInterface>;
  id: Scalars['ID'];
  /** E.g. 'Regular' or 'Regular Italic' */
  name: Scalars['String'];
  svg: Scalars['String'];
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
};

export type CMS_SSR_CustomImage = {
  __typename: 'CMS_SSR_CustomImage';
  aspectRatio: Scalars['Float'];
  collection: CMS_SSR_CollectionObjectType;
  createdAt: Scalars['CMS_SSR_DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize: Maybe<Scalars['Int']>;
  focalPointHeight: Maybe<Scalars['Int']>;
  focalPointWidth: Maybe<Scalars['Int']>;
  focalPointX: Maybe<Scalars['Int']>;
  focalPointY: Maybe<Scalars['Int']>;
  hasAlpha: Maybe<Scalars['Boolean']>;
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  isSvg: Scalars['Boolean'];
  placeholderColor: Maybe<Scalars['String']>;
  rendition: Maybe<CMS_SSR_CustomRendition>;
  sizes: Scalars['String'];
  /** @deprecated Use the `url` attribute */
  src: Scalars['String'];
  srcSet: Maybe<Scalars['String']>;
  tags: Array<CMS_SSR_TagObjectType>;
  title: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Int'];
};


export type CMS_SSR_CustomImagerenditionArgs = {
  bgcolor?: InputMaybe<Scalars['String']>;
  fill?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  jpegquality?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['String']>;
  min?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  webpquality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type CMS_SSR_CustomImagesrcSetArgs = {
  format?: InputMaybe<Scalars['String']>;
  preserveSvg?: InputMaybe<Scalars['Boolean']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CMS_SSR_CustomRendition = {
  __typename: 'CMS_SSR_CustomRendition';
  alt: Scalars['String'];
  backgroundPositionStyle: Scalars['String'];
  file: Scalars['String'];
  filterSpec: Scalars['String'];
  focalPoint: Maybe<Scalars['String']>;
  focalPointKey: Scalars['String'];
  height: Scalars['Int'];
  id: Maybe<Scalars['ID']>;
  image: CMS_SSR_CustomImage;
  url: Scalars['String'];
  width: Scalars['Int'];
};

export type CMS_SSR_DateBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DateBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_DateBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_DateTimeBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DateTimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_DateTimeBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_DecimalBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DecimalBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_DesignerLink = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DesignerLink';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type CMS_SSR_DiscountInterface = {
  __typename: 'CMS_SSR_DiscountInterface';
  /** Discount in cart base currency */
  amount: Scalars['Float'];
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Discount in percentage of (subtotal minus fixed amount discounts) */
  percentage: Scalars['Int'];
  type: CMS_SSR_DiscountType;
};

/** Type of Discount */
export enum CMS_SSR_DiscountType {
  PACKAGE = 'PACKAGE',
  STANDARD = 'STANDARD'
}

/** Debugging information for the current query. */
export type CMS_SSR_DjangoDebug = {
  __typename: 'CMS_SSR_DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions: Maybe<Array<Maybe<CMS_SSR_DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql: Maybe<Array<Maybe<CMS_SSR_DjangoDebugSQL>>>;
};

/** Represents a single exception raised. */
export type CMS_SSR_DjangoDebugException = {
  __typename: 'CMS_SSR_DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type CMS_SSR_DjangoDebugSQL = {
  __typename: 'CMS_SSR_DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type CMS_SSR_DocumentChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_DocumentChooserBlock';
  blockType: Scalars['String'];
  document: Maybe<CMS_SSR_DocumentObjectType>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

/**
 * Base document type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_DocumentObjectType = {
  __typename: 'CMS_SSR_DocumentObjectType';
  collection: CMS_SSR_CollectionObjectType;
  createdAt: Scalars['CMS_SSR_DateTime'];
  file: Scalars['String'];
  fileHash: Scalars['String'];
  fileSize: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  tags: Array<CMS_SSR_TagObjectType>;
  title: Scalars['String'];
  uploadedByUser: Maybe<CMS_SSR_UserInterface>;
  url: Scalars['String'];
};

export type CMS_SSR_EmailBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_EmailBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_EmbedBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_EmbedBlock';
  blockType: Scalars['String'];
  embed: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawEmbed: Maybe<Scalars['CMS_SSR_JSONString']>;
  rawValue: Scalars['String'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_EulaInterface = {
  __typename: 'CMS_SSR_EulaInterface';
  date: Scalars['CMS_SSR_DateTime'];
  introHtml: Array<Scalars['String']>;
  /** Licence type IDs */
  licenceTypeId: CMS_SSR_LicenceTypeId;
  sections: Array<CMS_SSR_EulaSectionInterface>;
  shortName: Scalars['String'];
  title: Scalars['String'];
};

export type CMS_SSR_EulaSectionInterface = {
  __typename: 'CMS_SSR_EulaSectionInterface';
  id: Scalars['String'];
  num: Scalars['Int'];
  subSections: Array<CMS_SSR_EulaSubSectionInterface>;
  title: Scalars['String'];
};

export type CMS_SSR_EulaSubSectionInterface = {
  __typename: 'CMS_SSR_EulaSubSectionInterface';
  contentHtml: Scalars['String'];
  num: Scalars['Int'];
  title: Maybe<Scalars['String']>;
};

export type CMS_SSR_FeaturedImageLinkBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_FeaturedImageLinkBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_FloatBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_FloatBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_FontFamilyGroupInterface = {
  __typename: 'CMS_SSR_FontFamilyGroupInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  campaign: Maybe<CMS_SSR_CampaignInterface>;
  colorSchemes: Array<CMS_SSR_ColorSchemeInterface>;
  cssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  /** 'Continue Reading' link of Information section */
  designInformationPage: Maybe<CMS_SSR_BlogPage>;
  fontFamilies: Array<CMS_SSR_FontFamilyInterface>;
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontUri: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  informationIntro: Maybe<Scalars['String']>;
  /** When checked this group will behave as a Collection. This means it can be seen as such on the site, can be purchased. */
  isCollection: Scalars['Boolean'];
  /** When checked this group show highlighted as 'New'. */
  isNew: Scalars['Boolean'];
  name: Scalars['String'];
  pdfSpecimen: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  showOnHomepage: Scalars['Boolean'];
  slug: Scalars['String'];
  svgHeading: Maybe<Scalars['String']>;
  svgNavigation: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
};

export type CMS_SSR_FontFamilyInterface = {
  __typename: 'CMS_SSR_FontFamilyInterface';
  awards: Array<CMS_SSR_AwardInterface>;
  campaign: Maybe<CMS_SSR_CampaignInterface>;
  classification: Array<Scalars['String']>;
  creditCollaborators: Array<Scalars['String']>;
  creditDesign: Array<Scalars['String']>;
  creditEngineering: Array<Scalars['String']>;
  cssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  featuredInUsePosts: Maybe<Array<CMS_SSR_PageInterface>>;
  fontFamilyGroup: CMS_SSR_FontFamilyGroupInterface;
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontStyles: Array<CMS_SSR_FontStyleInterface>;
  fontUri: Scalars['String'];
  fullName: Scalars['String'];
  glyphCountPerItalicStyle: Scalars['Int'];
  glyphCountPerRomanStyle: Scalars['Int'];
  glyphCountTotal: Scalars['Int'];
  hasVariableFonts: Scalars['Boolean'];
  id: Scalars['ID'];
  isPreRelease: Scalars['Boolean'];
  kerningPairCountPerStyle: Scalars['Int'];
  mainFontStyle: CMS_SSR_FontStyleInterface;
  mainSubfamily: Maybe<CMS_SSR_FontSubfamilyInterface>;
  name: Scalars['String'];
  notableDetails: Array<CMS_SSR_FontFamilyNotableDetailInterface>;
  openTypeFeatures: Array<CMS_SSR_FontOpenTypeFeatureInterface>;
  opentypeSpecimens: Array<CMS_SSR_FontFamilyOpenTypeFeatureInterface>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  release: Maybe<Scalars['CMS_SSR_Date']>;
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  /** The recommended max length is 160 characters, but this is not enforced. */
  seoDescription: Scalars['String'];
  /** A 1200x630 image to use as a preview when the font’s link is shared (e.g. on social media). */
  seoImage: Scalars['String'];
  /** Recommended limit of 60 characters, hard limit of 255 characters. If no custom title is provided one will be constructed. */
  seoTitle: Scalars['String'];
  slug: Scalars['String'];
  subfamilies: Array<CMS_SSR_FontSubfamilyInterface>;
  supportedLanguages: Array<CMS_SSR_LanguageInterface>;
  svgHeading: Maybe<Scalars['String']>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  variationAxes: Array<CMS_SSR_FontVariationAxisInterface>;
  versionNumber: Maybe<Scalars['Float']>;
  vfItalicFiles: Maybe<CMS_SSR_FontFilesInterface>;
  vfRomanFiles: Maybe<CMS_SSR_FontFilesInterface>;
};


export type CMS_SSR_FontFamilyInterfacefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CMS_SSR_FontFamilyNotableDetailInterface = {
  __typename: 'CMS_SSR_FontFamilyNotableDetailInterface';
  id: Scalars['ID'];
  svg: Scalars['String'];
};

export type CMS_SSR_FontFamilyOpenTypeFeatureInterface = {
  __typename: 'CMS_SSR_FontFamilyOpenTypeFeatureInterface';
  customDescription: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: CMS_SSR_SpecimenFontFamilyOpenTypeFeatureTypeChoices;
};

export type CMS_SSR_FontFilesInterface = {
  __typename: 'CMS_SSR_FontFilesInterface';
  id: Scalars['ID'];
  metrics: CMS_SSR_FontMetricsInterface;
  versionNumber: Scalars['CMS_SSR_Decimal'];
  woff2FileSize: Maybe<Scalars['Int']>;
  woffFile: Scalars['String'];
};

export type CMS_SSR_FontMetricsInterface = {
  __typename: 'CMS_SSR_FontMetricsInterface';
  ascentCalc: Scalars['Int'];
  ascentHhea: Scalars['Int'];
  ascentTypoOs2: Scalars['Int'];
  ascentWinOs2: Scalars['Int'];
  capHeightCalc: Scalars['Int'];
  capHeightOs2: Scalars['Int'];
  created: Scalars['CMS_SSR_DateTime'];
  descentCalc: Scalars['Int'];
  descentHhea: Scalars['Int'];
  descentTypoOs2: Scalars['Int'];
  descentWinOs2: Scalars['Int'];
  glyphCount: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isMonospace: Scalars['Boolean'];
  kerningPairCount: Maybe<Scalars['Int']>;
  lineGapHhea: Scalars['Int'];
  lineGapTypoOs2: Scalars['Int'];
  modified: Scalars['CMS_SSR_DateTime'];
  unitsPerEmHead: Scalars['Int'];
  uuid: Scalars['CMS_SSR_UUID'];
  xHeightOs2: Scalars['Int'];
};

export type CMS_SSR_FontOpenTypeFeatureInterface = {
  __typename: 'CMS_SSR_FontOpenTypeFeatureInterface';
  affectedGlyphs: Array<Scalars['String']>;
  allGlyphs: Maybe<Scalars['String']>;
  created: Scalars['CMS_SSR_DateTime'];
  /** Overrides default "All glyphs" */
  customAllGlyphs: Maybe<Scalars['String']>;
  /** Overrides default description */
  customDescription: Maybe<Scalars['String']>;
  /** Overrides default example */
  customExample: Maybe<Scalars['String']>;
  /** Overrides default label */
  customLabel: Maybe<Scalars['String']>;
  defaultAllGlyphs: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  example: Maybe<Scalars['String']>;
  fontStyles: Array<CMS_SSR_FontStyleInterface>;
  hasSafariSpaceSubBug: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Maybe<Scalars['String']>;
  /** If checked, this feature will be one to load initially on the specimen page */
  loadAsDefault: Scalars['Boolean'];
  modified: Scalars['CMS_SSR_DateTime'];
  /** Any secondary OpenType tags that need to be enabled for the main feature to work */
  secondaryTags: Array<Scalars['String']>;
  tag: Scalars['String'];
  uuid: Scalars['CMS_SSR_UUID'];
};

export type CMS_SSR_FontProductInterface = {
  __typename: 'CMS_SSR_FontProductInterface';
  cssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  fontId: Scalars['ID'];
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontUri: Scalars['String'];
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  typographicRanking: Maybe<Scalars['Int']>;
};

/** Font product type */
export enum CMS_SSR_FontProductTypeChoice {
  FONTFAMILY = 'FONTFAMILY',
  FONTFAMILYGROUP = 'FONTFAMILYGROUP',
  FONTSTYLE = 'FONTSTYLE'
}

/** Full FontStyle interface for SSR API */
export type CMS_SSR_FontStyleInterface = {
  __typename: 'CMS_SSR_FontStyleInterface';
  cssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  fontFamilySlug: Scalars['String'];
  fontProductType: CMS_SSR_FontProductTypeChoice;
  fontSizeMultiplier: Scalars['Float'];
  fontStyleCount: Scalars['Int'];
  fontStyleIdsByFamilyId: Array<CMS_SSR_ProductFontIds>;
  fontSubfamily: Maybe<CMS_SSR_FontSubfamilyInterface>;
  fontUri: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  openTypeFeatures: Array<CMS_SSR_FontOpenTypeFeatureInterface>;
  otfFiles: Maybe<CMS_SSR_FontFilesInterface>;
  /** Recommended pixel size */
  pixelSize: Maybe<Scalars['Int']>;
  pointSize: Maybe<Scalars['Float']>;
  productName: Scalars['String'];
  productSubtitle: Scalars['String'];
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  ttfFiles: Maybe<CMS_SSR_FontFilesInterface>;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
};

export type CMS_SSR_FontStyleWithCorrespondingStyles = {
  __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles';
  boldCssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  id: Scalars['ID'];
  italicCssRenderInfo: Maybe<CMS_SSR_CssRenderInfo>;
  name: Scalars['String'];
  pixelSize: Maybe<Scalars['Int']>;
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  variableAxes: Maybe<Array<Maybe<CMS_SSR_FontVariationAxisInterface>>>;
  weight: Scalars['Int'];
};

export type CMS_SSR_FontStyleWithWords = {
  __typename: 'CMS_SSR_FontStyleWithWords';
  cssRenderInfo: CMS_SSR_CssRenderInfo;
  id: Scalars['ID'];
  isItalic: Scalars['Boolean'];
  name: Scalars['String'];
  renderFontMetrics: Maybe<CMS_SSR_FontMetricsInterface>;
  variableAxes: Maybe<Array<Maybe<CMS_SSR_FontVariationAxisInterface>>>;
  /** Styles will be ordered by this. */
  weight: Scalars['Int'];
  words: Array<CMS_SSR_SpecimenWord>;
};

export type CMS_SSR_FontSubfamilyInterface = {
  __typename: 'CMS_SSR_FontSubfamilyInterface';
  id: Scalars['ID'];
  /** Short name without family name, e.g. 'A' for 'Die Grotesk A' */
  name: Scalars['String'];
};

export type CMS_SSR_FontVariationAxisInterface = {
  __typename: 'CMS_SSR_FontVariationAxisInterface';
  created: Scalars['CMS_SSR_DateTime'];
  defaultValue: Scalars['Float'];
  id: Scalars['ID'];
  maxValue: Scalars['Float'];
  minValue: Scalars['Float'];
  modified: Scalars['CMS_SSR_DateTime'];
  name: Scalars['String'];
  tag: Scalars['String'];
  uuid: Scalars['CMS_SSR_UUID'];
};

export type CMS_SSR_FontVariationInstanceAxisValueInterface = {
  __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface';
  tag: Scalars['String'];
  value: Scalars['Float'];
};

export type CMS_SSR_FontsInUseDetailPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_FontsInUseDetailPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  blurbImage: CMS_SSR_CustomImage;
  body: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  categories: Maybe<Array<CMS_SSR_FontsInUseDetailPageMediaTag>>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  designerLinks: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  feedImage: Maybe<CMS_SSR_CustomImage>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontFamilies: Maybe<Array<CMS_SSR_FontFamilyInterface>>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  mediaCount: Scalars['Int'];
  nextSiblings: Array<CMS_SSR_PageInterface>;
  noindex: Scalars['Boolean'];
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  postDate: Scalars['CMS_SSR_DateTime'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_FontsInUseDetailPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagecategoriesArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseDetailPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_FontsInUseDetailPageFontFamily = {
  __typename: 'CMS_SSR_FontsInUseDetailPageFontFamily';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_FontsInUseDetailPageMediaTag = {
  __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag';
  id: Maybe<Scalars['ID']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
};

export type CMS_SSR_FontsInUseIndexPage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_FontsInUseIndexPage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_FontsInUseIndexPageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_FontsInUseIndexPagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CMS_SSR_FontsSpecimenConfigLetterCaseChoices {
  /** lower case */
  LOWER_CASE = 'LOWER_CASE',
  /** Sentence case */
  SENTENCE_CASE = 'SENTENCE_CASE',
  /** Title Case */
  TITLE_CASE = 'TITLE_CASE',
  /** unAltered */
  UNALTERED = 'UNALTERED',
  /** UPPER CASE */
  UPPER_CASE = 'UPPER_CASE'
}

/** An enumeration. */
export enum CMS_SSR_FontsSpecimenConfigSpecimenTypeChoices {
  /** BIG */
  BIG = 'BIG',
  /** MEDIUM */
  MEDIUM = 'MEDIUM',
  /** SMALL */
  SMALL = 'SMALL'
}

export type CMS_SSR_HeadingBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HeadingBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  title: Scalars['String'];
};

export type CMS_SSR_HeroVideoAndImageBlocks = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HeroVideoAndImageBlocks';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_HomePage = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_HomePage';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  campaigns: Maybe<Array<CMS_SSR_HomePageCampaign>>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  featuredBlogPosts: Maybe<Array<Maybe<CMS_SSR_BlogPage>>>;
  featuredFonts: Maybe<Array<CMS_SSR_FontFamilyGroupInterface>>;
  featuredInUsePosts: Maybe<Array<Maybe<CMS_SSR_FontsInUseDetailPage>>>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_HomePageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagecampaignsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagefeaturedBlogPostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagefeaturedInUsePostsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_HomePagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_HomePageCampaign = {
  __typename: 'CMS_SSR_HomePageCampaign';
  campaign: CMS_SSR_CampaignInterface;
  fontFamilyGroup: CMS_SSR_FontFamilyGroupInterface;
  id: Maybe<Scalars['ID']>;
  sortOrder: Maybe<Scalars['Int']>;
};

export type CMS_SSR_HomepageCampaignBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HomepageCampaignBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  fontFamilyGroup: Maybe<CMS_SSR_FontFamilyGroupInterface>;
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

/** An enumeration. */
export enum CMS_SSR_HyperlinkColorChoice {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

export type CMS_SSR_HyperlinkedBaseBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_HyperlinkedBaseBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  linkText: Maybe<Scalars['String']>;
  linkTextColor: CMS_SSR_HyperlinkColorChoice;
  rawValue: Scalars['String'];
  url: Maybe<Scalars['String']>;
};

export type CMS_SSR_ImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  svg: Maybe<CMS_SSR_DocumentObjectType>;
};

export type CMS_SSR_ImageChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_ImageSectionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageSectionBlock';
  background: Maybe<Scalars['Boolean']>;
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  colorBackground: Maybe<Scalars['String']>;
  colorCaption: Maybe<Scalars['String']>;
  content: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  field: Scalars['String'];
  heading: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  noVerticalMargins: Maybe<Scalars['Boolean']>;
  rawValue: Scalars['String'];
  singleImageLayout: CMS_SSR_SingleImageLayoutChoice;
};

export type CMS_SSR_ImageWithPortraitBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ImageWithPortraitBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  landscapeImage: Maybe<CMS_SSR_CustomImage>;
  landscapeSvg: Maybe<CMS_SSR_DocumentObjectType>;
  portraitImage: Maybe<CMS_SSR_CustomImage>;
  portraitSvg: Maybe<CMS_SSR_DocumentObjectType>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_IntegerBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_IntegerBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['Int'];
};

export type CMS_SSR_InvoiceInterface = {
  __typename: 'CMS_SSR_InvoiceInterface';
  id: Scalars['ID'];
};

/** An enumeration. */
export enum CMS_SSR_KlimcartOrderStatusChoices {
  /** Delivered */
  DELIVERED = 'DELIVERED',
  /** New */
  NEW = 'NEW'
}

/** An enumeration. */
export enum CMS_SSR_KlimcartOrderUpgradeRequestStatusChoices {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  INVOICED = 'INVOICED',
  /** New */
  NEW = 'NEW'
}

export type CMS_SSR_LanguageInterface = {
  __typename: 'CMS_SSR_LanguageInterface';
  autonym: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Licence type IDs */
export enum CMS_SSR_LicenceTypeId {
  AD = 'AD',
  APP = 'APP',
  BROADCAST = 'BROADCAST',
  DESKTOP = 'DESKTOP',
  OEM = 'OEM',
  TEST = 'TEST',
  UDLA = 'UDLA',
  WEB = 'WEB'
}

export type CMS_SSR_LicenceTypeInterface = {
  __typename: 'CMS_SSR_LicenceTypeInterface';
  contractDetailsLabel: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Denotes whether this licence type can be purchased using the self-service cart checkout on the website. If not, then this licence type will only be available in the CMS. */
  isAvailableViaCart: Scalars['Boolean'];
  licenceSubjectLabel: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tieredLicensing: Array<CMS_SSR_TieredLicensingInterface>;
};

/** Licence type short names */
export enum CMS_SSR_LicenceTypeShortName {
  Advertising = 'Advertising',
  App = 'App',
  Broadcasting = 'Broadcasting',
  Desktop = 'Desktop',
  Enterprise = 'Enterprise',
  OEM = 'OEM',
  Test = 'Test',
  Web = 'Web'
}

export type CMS_SSR_LineItemInterface = {
  __typename: 'CMS_SSR_LineItemInterface';
  description: Maybe<Scalars['String']>;
  font: Maybe<CMS_SSR_FontProductInterface>;
  fontLicenceType: Maybe<CMS_SSR_LicenceTypeInterface>;
  fontSizeMultiplier: Scalars['Float'];
  id: Scalars['ID'];
  isRefunded: Scalars['Boolean'];
  price: Scalars['Float'];
  productName: Maybe<Scalars['String']>;
  productSubtitle: Maybe<Scalars['String']>;
  type: CMS_SSR_LineItemType;
  typographicRanking: Maybe<Scalars['Int']>;
  unitPrice: Scalars['Float'];
  upgradedOrderNumbers: Array<Scalars['String']>;
};

/** An enumeration. */
export enum CMS_SSR_LineItemType {
  CUSTOM = 'CUSTOM',
  GOODS = 'GOODS',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  UPGRADE = 'UPGRADE'
}

export type CMS_SSR_ListBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_ListBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  items: Array<CMS_SSR_StreamFieldInterface>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_MediumSpecimenSet = {
  __typename: 'CMS_SSR_MediumSpecimenSet';
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
};

export type CMS_SSR_OpenTypeFeatureMetaDataInterface = {
  __typename: 'CMS_SSR_OpenTypeFeatureMetaDataInterface';
  defaultAllGlyphs: Maybe<Scalars['String']>;
  defaultDescription: Maybe<Scalars['String']>;
  defaultExample: Maybe<Scalars['String']>;
  defaultLabel: Scalars['String'];
  tag: Scalars['String'];
};

export type CMS_SSR_OrderInterface = {
  __typename: 'CMS_SSR_OrderInterface';
  account: CMS_SSR_AccountInterface;
  /** Upgrade request for this order—if any—that hasn't been completed yet. */
  activeUpgradeRequest: Maybe<CMS_SSR_OrderUpgradeRequestInterface>;
  cart: CMS_SSR_CartInterface;
  date: Scalars['CMS_SSR_DateTime'];
  downloadFilename: Maybe<Scalars['String']>;
  downloadHasUpdate: Maybe<Scalars['Boolean']>;
  downloadLastModified: Maybe<Scalars['CMS_SSR_DateTime']>;
  downloadUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceUrl: Maybe<Scalars['String']>;
  orderNumber: Scalars['String'];
  status: CMS_SSR_KlimcartOrderStatusChoices;
  storageDownloadUrl: Maybe<Scalars['String']>;
};

export type CMS_SSR_OrderUpgradeRequestInterface = {
  __typename: 'CMS_SSR_OrderUpgradeRequestInterface';
  /** Customer's description of what to update and how. */
  details: Scalars['String'];
  id: Scalars['ID'];
  invoice: Maybe<CMS_SSR_InvoiceInterface>;
  licenceAppName: Maybe<Scalars['String']>;
  licenceWebDomainName: Maybe<Scalars['String']>;
  status: CMS_SSR_KlimcartOrderUpgradeRequestStatusChoices;
};

export type CMS_SSR_PackageDiscountPercentage = {
  __typename: 'CMS_SSR_PackageDiscountPercentage';
  discount: Scalars['Float'];
  fontProductType: CMS_SSR_FontProductTypeChoice;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_Page = CMS_SSR_PageInterface & {
  __typename: 'CMS_SSR_Page';
  aliasOf: Maybe<CMS_SSR_Page>;
  aliases: Array<CMS_SSR_Page>;
  ancestors: Array<CMS_SSR_PageInterface>;
  blogindexpage: Maybe<CMS_SSR_BlogIndexPage>;
  blogpage: Maybe<CMS_SSR_BlogPage>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  draftTitle: Scalars['String'];
  expireAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  expired: Scalars['Boolean'];
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  fontsinusedetailpage: Maybe<CMS_SSR_FontsInUseDetailPage>;
  fontsinuseindexpage: Maybe<CMS_SSR_FontsInUseIndexPage>;
  goLiveAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  hasUnpublishedChanges: Scalars['Boolean'];
  homepage: Maybe<CMS_SSR_HomePage>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  latestRevisionCreatedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  lockedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  lockedBy: Maybe<CMS_SSR_UserInterface>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  numchild: Scalars['Int'];
  owner: Maybe<CMS_SSR_UserInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  path: Scalars['String'];
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  sitesRootedHere: Array<CMS_SSR_SiteObjectType>;
  slug: Scalars['String'];
  title: Scalars['String'];
  translationKey: Scalars['CMS_SSR_UUID'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PageancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PagechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PagedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PagenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PagepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type CMS_SSR_PagesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_PageChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_PageChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  page: Maybe<CMS_SSR_PageInterface>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_PageInterface = {
  ancestors: Array<CMS_SSR_PageInterface>;
  children: Array<CMS_SSR_PageInterface>;
  contentType: Scalars['String'];
  depth: Maybe<Scalars['Int']>;
  descendants: Array<CMS_SSR_PageInterface>;
  firstPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  id: Maybe<Scalars['ID']>;
  lastPublishedAt: Maybe<Scalars['CMS_SSR_DateTime']>;
  live: Scalars['Boolean'];
  locked: Maybe<Scalars['Boolean']>;
  nextSiblings: Array<CMS_SSR_PageInterface>;
  pageType: Maybe<Scalars['String']>;
  parent: Maybe<CMS_SSR_PageInterface>;
  previousSiblings: Array<CMS_SSR_PageInterface>;
  searchDescription: Maybe<Scalars['String']>;
  searchScore: Maybe<Scalars['Float']>;
  seoTitle: Scalars['String'];
  showInMenus: Scalars['Boolean'];
  siblings: Array<CMS_SSR_PageInterface>;
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Maybe<Scalars['String']>;
  urlPath: Scalars['String'];
};


export type CMS_SSR_PageInterfaceancestorsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacechildrenArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacedescendantsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacenextSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacepreviousSiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_PageInterfacesiblingsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_PreviewSpecimenSet = {
  __typename: 'CMS_SSR_PreviewSpecimenSet';
  bigSpecimenSet: Maybe<CMS_SSR_BigSpecimenSet>;
  canBeProcessed: Scalars['Boolean'];
  /** Specimens will consist roughly of this amount of characters. Don't make this number too large as it will significantly impact page load size. */
  characterCount: Scalars['Int'];
  /** +/- character count tolerance. If Character Count is 100 and Character Count Tolerance is 20 then all specimens will be 80–120 characters in length. */
  characterCountTolerance: Scalars['Int'];
  /** Number of columns */
  columns: Scalars['Int'];
  /** Secondary number of columns. If greater than zero a second specimen will be rendered below the main specimen, with altered column count. */
  columnsSecondary: Scalars['Int'];
  created: Scalars['CMS_SSR_DateTime'];
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontFamily: CMS_SSR_FontFamilyInterface;
  /** Font size in vw (viewport width) units. */
  fontSize: Scalars['CMS_SSR_Decimal'];
  /** The secondary specimen's font size can be altered here. */
  fontSizeSecondary: Scalars['CMS_SSR_Decimal'];
  /** Which font styles to display specimens for. */
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  hasWordsToBeProcessed: Scalars['Boolean'];
  /** If checked this specimen config will show publicly on the site. */
  isActive: Scalars['Boolean'];
  isProcessed: Scalars['Boolean'];
  /** This will be True while this config is being actively processed, to prevent it from being picked up multiple times. */
  isProcessing: Scalars['Boolean'];
  /** Fix a particular letter case for all specimens. Unaltered keeps the case as taken from the original source. */
  letterCase: CMS_SSR_FontsSpecimenConfigLetterCaseChoices;
  /** Letter spacing to apply to all specimens. */
  letterSpacing: Scalars['CMS_SSR_Decimal'];
  /** The specimen will take up this many lines (rows). Don't make this number too large as it will significantly impact page load size. */
  lineCount: Scalars['Int'];
  /** The secondary specimen will take up this many lines (rows). */
  lineCountSecondary: Scalars['Int'];
  /** Line height to apply to all specimens. */
  lineHeight: Scalars['CMS_SSR_Decimal'];
  /** Maximum amount of processed words to calculate per font style and per random OpenType feature. The higher this number the longer processing will take. The resulting corpus size will be: (max. processed words) x (font style count) x (random OpenType feature count) */
  maxProcessedWords: Scalars['Int'];
  mediumSpecimenSet: Maybe<CMS_SSR_MediumSpecimenSet>;
  modified: Scalars['CMS_SSR_DateTime'];
  processedWords: Array<CMS_SSR_SpecimenWord>;
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  /** A word that is used as reference for specimen word width. Other specimens will try to match its width. */
  referenceWord: Scalars['String'];
  referenceWordCalculatedWidth: Maybe<Scalars['Int']>;
  /** Font Style that will be used to calculate the reference word width. */
  referenceWordFontStyle: Maybe<CMS_SSR_FontStyleWithCorrespondingStyles>;
  smallSpecimenSet: Maybe<CMS_SSR_SmallSpecimenSet>;
  specimenType: CMS_SSR_FontsSpecimenConfigSpecimenTypeChoices;
  /** How many specimens are displayed for each font style within the font family. Can be set to 0, which will mean no specimens will show at all. */
  specimensPerFontStyle: Scalars['Int'];
  uuid: Scalars['CMS_SSR_UUID'];
  /** Values between 0.005 (0.5%) and 0.02 (2%) seem to work best. This is negative tolerance, down from the width of the Reference Word. */
  widthTolerance: Scalars['CMS_SSR_Decimal'];
  /** Number of words at the start of the specimen that are to be set in Small Cap (smcp). */
  wordsInSmallCaps: Scalars['Int'];
};

export type CMS_SSR_ProductFontIds = {
  __typename: 'CMS_SSR_ProductFontIds';
  fontFamilyId: Scalars['ID'];
  fontStyleIds: Array<Scalars['ID']>;
};

export type CMS_SSR_QuestionAndAnswerBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_QuestionAndAnswerBlock';
  answer: Scalars['String'];
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  question: Scalars['String'];
  rawValue: Scalars['String'];
};

export type CMS_SSR_QuoteBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_QuoteBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  quote: Scalars['String'];
  rawValue: Scalars['String'];
};

export type CMS_SSR_RawHTMLBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RawHTMLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_Redirect = {
  __typename: 'CMS_SSR_Redirect';
  isPermanent: Scalars['Boolean'];
  newUrl: Maybe<Scalars['String']>;
  oldPath: Scalars['String'];
  oldUrl: Scalars['String'];
  page: Maybe<CMS_SSR_PageInterface>;
  site: CMS_SSR_SiteObjectType;
};

export type CMS_SSR_RegexBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RegexBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_RichTextBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_RichTextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_Search = CMS_SSR_BlogIndexPage | CMS_SSR_BlogPage | CMS_SSR_BlogPostFeaturedFont | CMS_SSR_BlogTag | CMS_SSR_CustomImage | CMS_SSR_CustomRendition | CMS_SSR_FontsInUseDetailPage | CMS_SSR_FontsInUseDetailPageFontFamily | CMS_SSR_FontsInUseDetailPageMediaTag | CMS_SSR_FontsInUseIndexPage | CMS_SSR_HomePage | CMS_SSR_HomePageCampaign | CMS_SSR_Page | CMS_SSR_SiteConfiguration | CMS_SSR_TaggedBlogBase;

/** Enum for search operator. */
export enum CMS_SSR_SearchOperatorEnum {
  AND = 'AND',
  OR = 'OR'
}

export type CMS_SSR_SimpleHyperlinkedImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: CMS_SSR_CustomImage;
  linkText: Scalars['String'];
  rawValue: Scalars['String'];
  title: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CMS_SSR_SimpleImageBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleImageBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  image: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  svg: Maybe<CMS_SSR_DocumentObjectType>;
};

export type CMS_SSR_SimpleImageSectionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleImageSectionBlock';
  background: Maybe<Scalars['Boolean']>;
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  colorBackground: Maybe<Scalars['String']>;
  content: Maybe<Array<Maybe<CMS_SSR_StreamFieldInterface>>>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  noVerticalMargins: Maybe<Scalars['Boolean']>;
  rawValue: Scalars['String'];
  singleImageLayout: CMS_SSR_SingleImageLayoutChoice;
};

export type CMS_SSR_SimpleVideoBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleVideoBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

export type CMS_SSR_SimpleVideoCaptionBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SimpleVideoCaptionBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CMS_SSR_SingleImageLayoutChoice {
  fullwidth = 'fullwidth',
  inline = 'inline',
  medium = 'medium'
}

export type CMS_SSR_SiteConfiguration = {
  __typename: 'CMS_SSR_SiteConfiguration';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_SiteObjectType = {
  __typename: 'CMS_SSR_SiteObjectType';
  hostname: Scalars['String'];
  id: Scalars['ID'];
  /** If true, this site will handle requests for all other hostnames that do not have a site entry of their own */
  isDefaultSite: Scalars['Boolean'];
  page: Maybe<CMS_SSR_PageInterface>;
  pages: Array<CMS_SSR_PageInterface>;
  /** Set this to something other than 80 if you need a specific port number to appear in URLs (e.g. development on port 8000). Does not affect request handling (so port forwarding still works). */
  port: Scalars['Int'];
  rootPage: CMS_SSR_Page;
  /** Human-readable name for the site. */
  siteName: Scalars['String'];
};


export type CMS_SSR_SiteObjectTypepageArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  urlPath?: InputMaybe<Scalars['String']>;
};


export type CMS_SSR_SiteObjectTypepagesArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  offset?: InputMaybe<Scalars['CMS_SSR_PositiveInt']>;
  order?: InputMaybe<Scalars['String']>;
  searchOperator?: InputMaybe<CMS_SSR_SearchOperatorEnum>;
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_SmallSpecimenSet = {
  __typename: 'CMS_SSR_SmallSpecimenSet';
  /** Specimens will consist roughly of this amount of characters. Don't make this number too large as it will significantly impact page load size. */
  characterCount: Scalars['Int'];
  /** Number of columns */
  columns: Scalars['Int'];
  /** Secondary number of columns. If greater than zero a second specimen will be rendered below the main specimen, with altered column count. */
  columnsSecondary: Scalars['Int'];
  /** Note that the following are always enabled (hard-coded): kern, liga, clig, calt */
  fixedOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  fontSize: Scalars['Float'];
  fontSizeSecondary: Scalars['Float'];
  fontStyles: Array<CMS_SSR_FontStyleWithCorrespondingStyles>;
  letterSpacing: Scalars['Float'];
  /** The specimen will take up this many lines (rows). Don't make this number too large as it will significantly impact page load size. */
  lineCount: Scalars['Int'];
  /** The secondary specimen will take up this many lines (rows). */
  lineCountSecondary: Scalars['Int'];
  lineHeight: Scalars['Float'];
  randomOpentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Likelihood that a random OpenType feature will be applied to a specimen, expressed as a percentage of total specimens on the page. E.g. 25% will mean 1 in 4 Big, Medium or Small specimens on the page will have a random feature applied. */
  randomOpentypeLikelihood: Scalars['Int'];
  sentences: Array<Scalars['String']>;
  /** Number of words at the start of the specimen that are to be set in Small Cap (smcp). */
  wordsInSmallCaps: Scalars['Int'];
};

export type CMS_SSR_SnippetChooserBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_SnippetChooserBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  snippet: Maybe<CMS_SSR_SnippetInterface>;
};

export type CMS_SSR_SnippetInterface = {
  contentType: Scalars['String'];
  snippetType: Scalars['String'];
};

/** An enumeration. */
export enum CMS_SSR_SpecimenFontFamilyOpenTypeFeatureTypeChoices {
  /** All small caps */
  C2SC = 'C2SC',
  /** Capital forms */
  CASE = 'CASE',
  /** Discretionary ligatures */
  DLIG = 'DLIG',
  /** Fractions */
  FRAC = 'FRAC',
  /** Ordinals */
  ORDN = 'ORDN',
  /** Lining numerals */
  PNUM_LNUM = 'PNUM_LNUM',
  /** Old-style numerals */
  PNUM_ONUM = 'PNUM_ONUM',
  /** Inferiors */
  SINF = 'SINF',
  /** Alternates */
  SSXX = 'SSXX',
  /** Superiors */
  SUPS = 'SUPS',
  /** Swashes */
  SWSH = 'SWSH',
  /** Tabular lining numerals */
  TNUM_LNUM = 'TNUM_LNUM',
  /** Tabular old-style numerals */
  TNUM_ONUM = 'TNUM_ONUM',
  /** Slashed zero */
  ZERO = 'ZERO'
}

export type CMS_SSR_SpecimenWord = {
  __typename: 'CMS_SSR_SpecimenWord';
  /** Proxy for easier querying */
  content: Scalars['String'];
  contentAscii: Scalars['String'];
  opentypeFeatures: Maybe<Array<Scalars['String']>>;
  /** Calculated width */
  width: Scalars['Int'];
};

export type CMS_SSR_StaticBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StaticBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_StreamBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StreamBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StreamFieldBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StreamFieldBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_StreamFieldInterface = {
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StructBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_StructBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
};

export type CMS_SSR_StyleDiscountPercentage = {
  __typename: 'CMS_SSR_StyleDiscountPercentage';
  discount: Scalars['Float'];
  quantity: Scalars['Int'];
};

export type CMS_SSR_TagInterface = {
  __typename: 'CMS_SSR_TagInterface';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type CMS_SSR_TagObjectType = {
  __typename: 'CMS_SSR_TagObjectType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CMS_SSR_TaggedBlogBase = {
  __typename: 'CMS_SSR_TaggedBlogBase';
  id: Maybe<Scalars['ID']>;
};

export type CMS_SSR_TestFontsInterface = {
  __typename: 'CMS_SSR_TestFontsInterface';
  /** Test font archive size in bytes */
  allFontsArchiveFilesize: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type CMS_SSR_TextBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_TextBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_TierInterface = {
  __typename: 'CMS_SSR_TierInterface';
  amount: Scalars['String'];
  hasContractDetailsField: Scalars['Boolean'];
  hasLicenceSubjectField: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Denotes if this is a tier that is subject to an Unlimited Licensing Agreement. */
  isUnlimited: Scalars['Boolean'];
  licenceType: CMS_SSR_LicenceTypeInterface;
  multiplier: Scalars['Float'];
  tieredLicence: CMS_SSR_TieredLicensingInterface;
  title: Scalars['String'];
  titleAbbrev: Scalars['String'];
};

export type CMS_SSR_TieredLicensingInterface = {
  __typename: 'CMS_SSR_TieredLicensingInterface';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  licenceType: CMS_SSR_LicenceTypeInterface;
  tiers: Array<CMS_SSR_TierInterface>;
  title: Scalars['String'];
  unitStr: Scalars['String'];
  unitStrAbbrev: Scalars['String'];
  unitStrAbbrevPlural: Scalars['String'];
  unitStrPlural: Scalars['String'];
};

export type CMS_SSR_TimeBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_TimeBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};


export type CMS_SSR_TimeBlockvalueArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type CMS_SSR_URLBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_URLBlock';
  blockType: Scalars['String'];
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  rawValue: Scalars['String'];
  value: Scalars['String'];
};

export type CMS_SSR_UserInterface = {
  __typename: 'CMS_SSR_UserInterface';
  billingAddress1: Maybe<Scalars['String']>;
  billingAddress2: Maybe<Scalars['String']>;
  billingCity: Maybe<Scalars['String']>;
  billingCompanyName: Maybe<Scalars['String']>;
  billingCountry: Maybe<CMS_SSR_CountryChoices>;
  billingPostcode: Maybe<Scalars['String']>;
  billingState: Maybe<Scalars['String']>;
  billingVatNumber: Maybe<Scalars['String']>;
  canRevert: Scalars['Boolean'];
  email: Scalars['String'];
  emailOptIn: Scalars['Boolean'];
  fullName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  /** Order history */
  orders: Array<CMS_SSR_OrderInterface>;
};


export type CMS_SSR_UserInterfaceordersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CMS_SSR_VideoBlock = CMS_SSR_StreamFieldInterface & {
  __typename: 'CMS_SSR_VideoBlock';
  blockType: Scalars['String'];
  blocks: Array<CMS_SSR_StreamFieldInterface>;
  caption: Maybe<Scalars['String']>;
  field: Scalars['String'];
  id: Maybe<Scalars['String']>;
  posterImage: Maybe<CMS_SSR_CustomImage>;
  rawValue: Scalars['String'];
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  video: Scalars['String'];
  videoAspectRatio: Maybe<Scalars['String']>;
};

export type CMS_SSR_VimeoVideoFileInterface = {
  __typename: 'CMS_SSR_VimeoVideoFileInterface';
  height: Scalars['Int'];
  id: Scalars['ID'];
  src: Scalars['String'];
  type: Scalars['String'];
  video: CMS_SSR_VimeoVideoInterface;
  width: Scalars['Int'];
};

export type CMS_SSR_VimeoVideoInterface = {
  __typename: 'CMS_SSR_VimeoVideoInterface';
  embedUrl: Scalars['String'];
  files: Array<CMS_SSR_VimeoVideoFileInterface>;
  height: Scalars['Int'];
  id: Scalars['ID'];
  title: Scalars['String'];
  width: Scalars['Int'];
};

export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type Directory = Node & {
  __typename: 'Directory';
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs: Maybe<Scalars['Float']>;
  changeTime: Scalars['Date'];
  children: Array<Node>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent: Maybe<Node>;
  prettySize: Scalars['String'];
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type DirectoryaccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryatimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorybirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorychangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryctimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorymodifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectorymtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type DirectoryConnection = {
  __typename: 'DirectoryConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  group: Array<DirectoryGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryConnectiondistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectiongroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryConnectionmaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionminArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionsumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectoryEdge = {
  __typename: 'DirectoryEdge';
  next: Maybe<Directory>;
  node: Directory;
  previous: Maybe<Directory>;
};

export type DirectoryFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
};

export type DirectoryFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type DirectoryGroupConnection = {
  __typename: 'DirectoryGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<DirectoryEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<DirectoryGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type DirectoryGroupConnectiondistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectiongroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DirectoryGroupConnectionmaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionminArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionsumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectorySortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
};

export enum FieldSelectorEnum {
  SELECT = 'SELECT'
}

export type File = Node & {
  __typename: 'File';
  absolutePath: Scalars['String'];
  accessTime: Scalars['Date'];
  atime: Scalars['Date'];
  atimeMs: Scalars['Float'];
  base: Scalars['String'];
  birthTime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs: Maybe<Scalars['Float']>;
  changeTime: Scalars['Date'];
  children: Array<Node>;
  ctime: Scalars['Date'];
  ctimeMs: Scalars['Float'];
  dev: Scalars['Int'];
  dir: Scalars['String'];
  ext: Scalars['String'];
  extension: Scalars['String'];
  gid: Scalars['Int'];
  id: Scalars['ID'];
  ino: Scalars['Float'];
  internal: Internal;
  mode: Scalars['Int'];
  modifiedTime: Scalars['Date'];
  mtime: Scalars['Date'];
  mtimeMs: Scalars['Float'];
  name: Scalars['String'];
  nlink: Scalars['Int'];
  parent: Maybe<Node>;
  prettySize: Scalars['String'];
  rdev: Scalars['Int'];
  relativeDirectory: Scalars['String'];
  relativePath: Scalars['String'];
  root: Scalars['String'];
  size: Scalars['Int'];
  sourceInstanceName: Scalars['String'];
  uid: Scalars['Int'];
};


export type FileaccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileatimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilebirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilechangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilectimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilemodifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FilemtimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type FileConnection = {
  __typename: 'FileConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  group: Array<FileGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileConnectiondistinctArgs = {
  field: FileFieldSelector;
};


export type FileConnectiongroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileConnectionmaxArgs = {
  field: FileFieldSelector;
};


export type FileConnectionminArgs = {
  field: FileFieldSelector;
};


export type FileConnectionsumArgs = {
  field: FileFieldSelector;
};

export type FileEdge = {
  __typename: 'FileEdge';
  next: Maybe<File>;
  node: File;
  previous: Maybe<File>;
};

export type FileFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
};

export type FileFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type FileGroupConnection = {
  __typename: 'FileGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<FileEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<FileGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type FileGroupConnectiondistinctArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectiongroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FileGroupConnectionmaxArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionminArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionsumArgs = {
  field: FileFieldSelector;
};

export type FileSortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
};

export type FloatQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type GraphQLSource = Node & {
  __typename: 'GraphQLSource';
  children: Array<Node>;
  fieldName: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
  typeName: Maybe<Scalars['String']>;
};

export type GraphQLSourceConnection = {
  __typename: 'GraphQLSourceConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<GraphQLSourceEdge>;
  group: Array<GraphQLSourceGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<GraphQLSource>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type GraphQLSourceConnectiondistinctArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceConnectiongroupArgs = {
  field: GraphQLSourceFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GraphQLSourceConnectionmaxArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceConnectionminArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceConnectionsumArgs = {
  field: GraphQLSourceFieldSelector;
};

export type GraphQLSourceEdge = {
  __typename: 'GraphQLSourceEdge';
  next: Maybe<GraphQLSource>;
  node: GraphQLSource;
  previous: Maybe<GraphQLSource>;
};

export type GraphQLSourceFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  fieldName?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  typeName?: InputMaybe<FieldSelectorEnum>;
};

export type GraphQLSourceFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  fieldName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  typeName?: InputMaybe<StringQueryOperatorInput>;
};

export type GraphQLSourceGroupConnection = {
  __typename: 'GraphQLSourceGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<GraphQLSourceEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<GraphQLSourceGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<GraphQLSource>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type GraphQLSourceGroupConnectiondistinctArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceGroupConnectiongroupArgs = {
  field: GraphQLSourceFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type GraphQLSourceGroupConnectionmaxArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceGroupConnectionminArgs = {
  field: GraphQLSourceFieldSelector;
};


export type GraphQLSourceGroupConnectionsumArgs = {
  field: GraphQLSourceFieldSelector;
};

export type GraphQLSourceSortInput = {
  children?: InputMaybe<NodeSortInput>;
  fieldName?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  typeName?: InputMaybe<SortOrderEnum>;
};

export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Internal = {
  __typename: 'Internal';
  content: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  contentFilePath: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  fieldOwners: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType: Maybe<Scalars['Boolean']>;
  mediaType: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFieldSelector = {
  content?: InputMaybe<FieldSelectorEnum>;
  contentDigest?: InputMaybe<FieldSelectorEnum>;
  contentFilePath?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  fieldOwners?: InputMaybe<FieldSelectorEnum>;
  ignoreType?: InputMaybe<FieldSelectorEnum>;
  mediaType?: InputMaybe<FieldSelectorEnum>;
  owner?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type InternalFilterInput = {
  content?: InputMaybe<StringQueryOperatorInput>;
  contentDigest?: InputMaybe<StringQueryOperatorInput>;
  contentFilePath?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  fieldOwners?: InputMaybe<StringQueryOperatorInput>;
  ignoreType?: InputMaybe<BooleanQueryOperatorInput>;
  mediaType?: InputMaybe<StringQueryOperatorInput>;
  owner?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type InternalSortInput = {
  content?: InputMaybe<SortOrderEnum>;
  contentDigest?: InputMaybe<SortOrderEnum>;
  contentFilePath?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  fieldOwners?: InputMaybe<SortOrderEnum>;
  ignoreType?: InputMaybe<SortOrderEnum>;
  mediaType?: InputMaybe<SortOrderEnum>;
  owner?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
};

export type JSONQueryOperatorInput = {
  eq?: InputMaybe<Scalars['JSON']>;
  glob?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  ne?: InputMaybe<Scalars['JSON']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  regex?: InputMaybe<Scalars['JSON']>;
};

/** Node Interface */
export type Node = {
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
};

export type NodeFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type NodeFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: InputMaybe<NodeFilterInput>;
};

export type NodeSortInput = {
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename: 'Query';
  allDirectory: DirectoryConnection;
  allFile: FileConnection;
  allGraphQlSource: GraphQLSourceConnection;
  allSite: SiteConnection;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  allSiteFunction: SiteFunctionConnection;
  allSitePage: SitePageConnection;
  allSitePlugin: SitePluginConnection;
  directory: Maybe<Directory>;
  file: Maybe<File>;
  graphQlSource: Maybe<GraphQLSource>;
  site: Maybe<Site>;
  siteBuildMetadata: Maybe<SiteBuildMetadata>;
  siteFunction: Maybe<SiteFunction>;
  sitePage: Maybe<SitePage>;
  sitePlugin: Maybe<SitePlugin>;
  ssr: CMS_SSR;
};


export type QueryallDirectoryArgs = {
  filter?: InputMaybe<DirectoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DirectorySortInput>>>;
};


export type QueryallFileArgs = {
  filter?: InputMaybe<FileFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<FileSortInput>>>;
};


export type QueryallGraphQlSourceArgs = {
  filter?: InputMaybe<GraphQLSourceFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<GraphQLSourceSortInput>>>;
};


export type QueryallSiteArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteSortInput>>>;
};


export type QueryallSiteBuildMetadataArgs = {
  filter?: InputMaybe<SiteBuildMetadataFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteBuildMetadataSortInput>>>;
};


export type QueryallSiteFunctionArgs = {
  filter?: InputMaybe<SiteFunctionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SiteFunctionSortInput>>>;
};


export type QueryallSitePageArgs = {
  filter?: InputMaybe<SitePageFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SitePageSortInput>>>;
};


export type QueryallSitePluginArgs = {
  filter?: InputMaybe<SitePluginFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SitePluginSortInput>>>;
};


export type QuerydirectoryArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QueryfileArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QuerygraphQlSourceArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  fieldName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  typeName?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysiteArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysiteBuildMetadataArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerysiteFunctionArgs = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerysitePageArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};


export type QuerysitePluginArgs = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JSONQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type Site = Node & {
  __typename: 'Site';
  buildTime: Maybe<Scalars['Date']>;
  children: Array<Node>;
  graphqlTypegen: Maybe<Scalars['Boolean']>;
  host: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internal: Internal;
  jsxRuntime: Maybe<Scalars['String']>;
  parent: Maybe<Node>;
  pathPrefix: Maybe<Scalars['String']>;
  polyfill: Maybe<Scalars['Boolean']>;
  port: Maybe<Scalars['Int']>;
  siteMetadata: Maybe<SiteSiteMetadata>;
  trailingSlash: Maybe<Scalars['String']>;
};


export type SitebuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  __typename: 'SiteBuildMetadata';
  buildTime: Maybe<Scalars['Date']>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  parent: Maybe<Node>;
};


export type SiteBuildMetadatabuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']>;
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  __typename: 'SiteBuildMetadataConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataConnectiondistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectiongroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataConnectionmaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionminArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionsumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataEdge = {
  __typename: 'SiteBuildMetadataEdge';
  next: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous: Maybe<SiteBuildMetadata>;
};

export type SiteBuildMetadataFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type SiteBuildMetadataFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SiteBuildMetadataGroupConnection = {
  __typename: 'SiteBuildMetadataGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteBuildMetadataEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteBuildMetadataGroupConnectiondistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectiongroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteBuildMetadataGroupConnectionmaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionminArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionsumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type SiteConnection = {
  __typename: 'SiteConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  group: Array<SiteGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteConnectiondistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectiongroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteConnectionmaxArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionminArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionsumArgs = {
  field: SiteFieldSelector;
};

export type SiteEdge = {
  __typename: 'SiteEdge';
  next: Maybe<Site>;
  node: Site;
  previous: Maybe<Site>;
};

export type SiteFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  graphqlTypegen?: InputMaybe<FieldSelectorEnum>;
  host?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  jsxRuntime?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pathPrefix?: InputMaybe<FieldSelectorEnum>;
  polyfill?: InputMaybe<FieldSelectorEnum>;
  port?: InputMaybe<FieldSelectorEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFieldSelector>;
  trailingSlash?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunction = Node & {
  __typename: 'SiteFunction';
  absoluteCompiledFilePath: Scalars['String'];
  children: Array<Node>;
  functionRoute: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  matchPath: Maybe<Scalars['String']>;
  originalAbsoluteFilePath: Scalars['String'];
  originalRelativeFilePath: Scalars['String'];
  parent: Maybe<Node>;
  pluginName: Scalars['String'];
  relativeCompiledFilePath: Scalars['String'];
};

export type SiteFunctionConnection = {
  __typename: 'SiteFunctionConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  group: Array<SiteFunctionGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionConnectiondistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectiongroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionConnectionmaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionminArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionsumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionEdge = {
  __typename: 'SiteFunctionEdge';
  next: Maybe<SiteFunction>;
  node: SiteFunction;
  previous: Maybe<SiteFunction>;
};

export type SiteFunctionFieldSelector = {
  absoluteCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  functionRoute?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  originalAbsoluteFilePath?: InputMaybe<FieldSelectorEnum>;
  originalRelativeFilePath?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginName?: InputMaybe<FieldSelectorEnum>;
  relativeCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFunctionFilterInput = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunctionGroupConnection = {
  __typename: 'SiteFunctionGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteFunctionEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteFunctionGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteFunctionGroupConnectiondistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectiongroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteFunctionGroupConnectionmaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionminArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionsumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionSortInput = {
  absoluteCompiledFilePath?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  functionRoute?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  matchPath?: InputMaybe<SortOrderEnum>;
  originalAbsoluteFilePath?: InputMaybe<SortOrderEnum>;
  originalRelativeFilePath?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginName?: InputMaybe<SortOrderEnum>;
  relativeCompiledFilePath?: InputMaybe<SortOrderEnum>;
};

export type SiteGroupConnection = {
  __typename: 'SiteGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SiteEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SiteGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SiteGroupConnectiondistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectiongroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SiteGroupConnectionmaxArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionminArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionsumArgs = {
  field: SiteFieldSelector;
};

export type SitePage = Node & {
  __typename: 'SitePage';
  children: Array<Node>;
  component: Scalars['String'];
  componentChunkName: Scalars['String'];
  id: Scalars['ID'];
  internal: Internal;
  internalComponentName: Scalars['String'];
  matchPath: Maybe<Scalars['String']>;
  pageContext: Maybe<Scalars['JSON']>;
  parent: Maybe<Node>;
  path: Scalars['String'];
  pluginCreator: Maybe<SitePlugin>;
};

export type SitePageConnection = {
  __typename: 'SitePageConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  group: Array<SitePageGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageConnectiondistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectiongroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageConnectionmaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionminArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionsumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageEdge = {
  __typename: 'SitePageEdge';
  next: Maybe<SitePage>;
  node: SitePage;
  previous: Maybe<SitePage>;
};

export type SitePageFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  component?: InputMaybe<FieldSelectorEnum>;
  componentChunkName?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalComponentName?: InputMaybe<FieldSelectorEnum>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  pageContext?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  path?: InputMaybe<FieldSelectorEnum>;
  pluginCreator?: InputMaybe<SitePluginFieldSelector>;
};

export type SitePageFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};

export type SitePageGroupConnection = {
  __typename: 'SitePageGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePageEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SitePageGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePageGroupConnectiondistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectiongroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePageGroupConnectionmaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionminArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionsumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageSortInput = {
  children?: InputMaybe<NodeSortInput>;
  component?: InputMaybe<SortOrderEnum>;
  componentChunkName?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalComponentName?: InputMaybe<SortOrderEnum>;
  matchPath?: InputMaybe<SortOrderEnum>;
  pageContext?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  path?: InputMaybe<SortOrderEnum>;
  pluginCreator?: InputMaybe<SitePluginSortInput>;
};

export type SitePlugin = Node & {
  __typename: 'SitePlugin';
  browserAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  children: Array<Node>;
  id: Scalars['ID'];
  internal: Internal;
  name: Maybe<Scalars['String']>;
  nodeAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  packageJson: Maybe<Scalars['JSON']>;
  parent: Maybe<Node>;
  pluginFilepath: Maybe<Scalars['String']>;
  pluginOptions: Maybe<Scalars['JSON']>;
  resolve: Maybe<Scalars['String']>;
  ssrAPIs: Maybe<Array<Maybe<Scalars['String']>>>;
  version: Maybe<Scalars['String']>;
};

export type SitePluginConnection = {
  __typename: 'SitePluginConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  group: Array<SitePluginGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginConnectiondistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectiongroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginConnectionmaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionminArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionsumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginEdge = {
  __typename: 'SitePluginEdge';
  next: Maybe<SitePlugin>;
  node: SitePlugin;
  previous: Maybe<SitePlugin>;
};

export type SitePluginFieldSelector = {
  browserAPIs?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  nodeAPIs?: InputMaybe<FieldSelectorEnum>;
  packageJson?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginFilepath?: InputMaybe<FieldSelectorEnum>;
  pluginOptions?: InputMaybe<FieldSelectorEnum>;
  resolve?: InputMaybe<FieldSelectorEnum>;
  ssrAPIs?: InputMaybe<FieldSelectorEnum>;
  version?: InputMaybe<FieldSelectorEnum>;
};

export type SitePluginFilterInput = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JSONQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JSONQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type SitePluginGroupConnection = {
  __typename: 'SitePluginGroupConnection';
  distinct: Array<Scalars['String']>;
  edges: Array<SitePluginEdge>;
  field: Scalars['String'];
  fieldValue: Maybe<Scalars['String']>;
  group: Array<SitePluginGroupConnection>;
  max: Maybe<Scalars['Float']>;
  min: Maybe<Scalars['Float']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};


export type SitePluginGroupConnectiondistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectiongroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SitePluginGroupConnectionmaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionminArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionsumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginSortInput = {
  browserAPIs?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  nodeAPIs?: InputMaybe<SortOrderEnum>;
  packageJson?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginFilepath?: InputMaybe<SortOrderEnum>;
  pluginOptions?: InputMaybe<SortOrderEnum>;
  resolve?: InputMaybe<SortOrderEnum>;
  ssrAPIs?: InputMaybe<SortOrderEnum>;
  version?: InputMaybe<SortOrderEnum>;
};

export type SiteSiteMetadata = {
  __typename: 'SiteSiteMetadata';
  description: Maybe<Scalars['String']>;
  siteUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFieldSelector = {
  description?: InputMaybe<FieldSelectorEnum>;
  siteUrl?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SiteSiteMetadataFilterInput = {
  description?: InputMaybe<StringQueryOperatorInput>;
  siteUrl?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteSiteMetadataSortInput = {
  description?: InputMaybe<SortOrderEnum>;
  siteUrl?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SiteSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  graphqlTypegen?: InputMaybe<SortOrderEnum>;
  host?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  jsxRuntime?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pathPrefix?: InputMaybe<SortOrderEnum>;
  polyfill?: InputMaybe<SortOrderEnum>;
  port?: InputMaybe<SortOrderEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataSortInput>;
  trailingSlash?: InputMaybe<SortOrderEnum>;
};

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']>;
  glob?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['String']>;
};

export type ActiveLicenceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveLicenceTypesQuery = { ssr: { __typename: 'CMS_SSR', activeLicenceTypes: Array<{ __typename: 'CMS_SSR_LicenceTypeInterface', id: string, name: string, isAvailableViaCart: boolean, tieredLicensing: Array<{ __typename: 'CMS_SSR_TieredLicensingInterface', id: string, title: string, isActive: boolean, unitStr: string, unitStrPlural: string, tiers: Array<{ __typename: 'CMS_SSR_TierInterface', id: string, title: string, titleAbbrev: string, amount: string, multiplier: number, isActive: boolean, isUnlimited: boolean, licenceType: { __typename: 'CMS_SSR_LicenceTypeInterface', id: string }, tieredLicence: { __typename: 'CMS_SSR_TieredLicensingInterface', id: string } }> }> }> } };

export type AwardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AwardsQuery = { ssr: { __typename: 'CMS_SSR', awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, name: string, year: number, receivedFor: string | null, sortOrder: number, essentialContribution: boolean, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', isPreRelease: boolean, name: string, slug: string, typographicRanking: number | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', isCollection: boolean, name: string, slug: string, typographicRanking: number | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', isPreRelease: boolean, name: string, slug: string, typographicRanking: number | null }> }>, customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', isPreRelease: boolean, name: string, slug: string | null }> }> } };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { ssr: { __typename: 'CMS_SSR', config: { __typename: 'CMS_SSR_ConfigInterface', userTestingHostname: string | null, userTestingCheckoutAllowed: boolean, isProductionSite: boolean, unitPriceFontStyle: number, businessName: string, businessUrl: string, emailSupport: string, baseCurrency: CMS_SSR_CurrencyChoices, buildDateTime: any, customOpentypeHtmlTagNames: Array<string>, awardPageIntro: string, crossLicenceDiscountPercentage: number, licenceTypeShortNames: Array<CMS_SSR_LicenceTypeShortName>, bigSpecimenRefFontSizePx: number, userTestingFontFamilyGroupWhitelist: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string }>, eulas: Array<{ __typename: 'CMS_SSR_EulaInterface', licenceTypeId: CMS_SSR_LicenceTypeId, title: string, shortName: string }>, countries: Array<{ __typename: 'CMS_SSR_CountryInterface', name: string, code: CMS_SSR_CountryChoices, taxId: string | null }>, styleDiscountPercentages: Array<{ __typename: 'CMS_SSR_StyleDiscountPercentage', quantity: number, discount: number }>, packageDiscountPercentages: Array<{ __typename: 'CMS_SSR_PackageDiscountPercentage', fontProductType: CMS_SSR_FontProductTypeChoice, discount: number }>, openTypeFeatureMetaData: Array<{ __typename: 'CMS_SSR_OpenTypeFeatureMetaDataInterface', tag: string, defaultLabel: string, defaultExample: string | null, defaultAllGlyphs: string | null, defaultDescription: string | null }>, languages: Array<{ __typename: 'CMS_SSR_LanguageInterface', id: string, name: string, autonym: string | null }> } } };

export type CustomFontsStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomFontsStubsQuery = { ssr: { __typename: 'CMS_SSR', customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', creditClient: Array<string>, id: string, isPreRelease: boolean, name: string, slug: string | null, svgNavigation: string | null, backgroundColor: string, foregroundColor: string, highlightColor: string, styles: Array<{ __typename: 'CMS_SSR_CustomFontStyleInterface', name: string, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', name: string, sortOrder: number } | null }> }> } };

export type AllFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFontsQuery = { ssr: { __typename: 'CMS_SSR', fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, svgNavigation: string | null, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string, productName: string }, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null }> }> } };

export type InUsePostStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type InUsePostStubsQuery = { ssr: { __typename: 'CMS_SSR', inUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, noindex: boolean, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', name: string, slug: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null }> | null } };

export type TestFontsFilesizeQueryVariables = Exact<{ [key: string]: never; }>;


export type TestFontsFilesizeQuery = { ssr: { __typename: 'CMS_SSR', testFonts: { __typename: 'CMS_SSR_TestFontsInterface', allFontsArchiveFilesize: number | null } } };

export type FeaturedInUsePostFragment = { __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null };

export type ColorSchemeFragment = { __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null };

export type FontMetricsFragment = { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number };

export type CssRenderInfoFragment = { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null };

export type FontVariationAxesFragment = { __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number };

export type BlogPostStubFragment = { __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null };

export type FontStyleFragment = { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null, hasSafariSpaceSubBug: boolean }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null };

export type CampaignImageFragment = { __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorBackground: string | null };

export type VimeoVideoFragment = { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> };

export type CampaignVideoFragment = { __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null };

export type CampaignCodeFragment = { __typename: 'CMS_SSR_CampaignCodeInterface', id: string, animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices, options: any };

export type AwardFragment = { __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number };

export type EulasQueryVariables = Exact<{ [key: string]: never; }>;


export type EulasQuery = { ssr: { __typename: 'CMS_SSR', config: { __typename: 'CMS_SSR_ConfigInterface', eulas: Array<{ __typename: 'CMS_SSR_EulaInterface', licenceTypeId: CMS_SSR_LicenceTypeId, title: string, shortName: string, date: any, introHtml: Array<string>, sections: Array<{ __typename: 'CMS_SSR_EulaSectionInterface', title: string, id: string, num: number, subSections: Array<{ __typename: 'CMS_SSR_EulaSubSectionInterface', title: string | null, num: number, contentHtml: string }> }> }> } } };

export type CampaignFragment = { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }>, codes: Array<{ __typename: 'CMS_SSR_CampaignCodeInterface', id: string, animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices, options: any }> };

export type HomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageQuery = { ssr: { __typename: 'CMS_SSR', homepage: { __typename: 'CMS_SSR_HomePage', slug: string, title: string, featuredFonts: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, svgNavigation: string | null, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null }> }> | null, campaigns: Array<{ __typename: 'CMS_SSR_HomePageCampaign', fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string, name: string, isCollection: boolean, svgNavigation: string | null, typographicRanking: number | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, isPreRelease: boolean }>, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }> }, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }>, codes: Array<{ __typename: 'CMS_SSR_CampaignCodeInterface', id: string, animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices, options: any }> } }> | null, featuredBlogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null } | null> | null, featuredInUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null } | null> | null } } };

export type FontFamiliesQueryVariables = Exact<{ [key: string]: never; }>;


export type FontFamiliesQuery = { ssr: { __typename: 'CMS_SSR', fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, fontSizeMultiplier: number, fontStyleCount: number, creditDesign: Array<string>, creditEngineering: Array<string>, creditCollaborators: Array<string>, release: any | null, classification: Array<string>, typographicRanking: number | null, svgHeading: string | null, seoTitle: string, seoDescription: string, seoImage: string, isPreRelease: boolean, hasVariableFonts: boolean, versionNumber: number | null, glyphCountPerRomanStyle: number, glyphCountPerItalicStyle: number, glyphCountTotal: number, kerningPairCountPerStyle: number, supportedLanguages: Array<{ __typename: 'CMS_SSR_LanguageInterface', id: string }>, variationAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number }>, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, secondaryTags: Array<string>, label: string | null, description: string | null, example: string | null, allGlyphs: string | null, loadAsDefault: boolean, affectedGlyphs: Array<string>, hasSafariSpaceSubBug: boolean, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string }> }>, vfRomanFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, vfItalicFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }>, mainSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }>, codes: Array<{ __typename: 'CMS_SSR_CampaignCodeInterface', id: string, animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices, options: any }> } | null, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, otfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woffFile: string, metrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } } | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null, hasSafariSpaceSubBug: boolean }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null }>, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string }, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, notableDetails: Array<{ __typename: 'CMS_SSR_FontFamilyNotableDetailInterface', svg: string }>, featuredInUsePosts: Array<{ __typename: 'CMS_SSR_BlogIndexPage' } | { __typename: 'CMS_SSR_BlogPage' } | { __typename: 'CMS_SSR_FontsInUseDetailPage', id: string | null, title: string, seoTitle: string, slug: string, postDate: any, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', id: string | null, name: string | null, slug: string | null }> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string } }> | null } | { __typename: 'CMS_SSR_FontsInUseIndexPage' } | { __typename: 'CMS_SSR_HomePage' } | { __typename: 'CMS_SSR_Page' }> | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, isCollection: boolean, informationIntro: string | null, pdfSpecimen: string | null, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', slug: string, name: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }> }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }> } }> } };

export type BigSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type BigSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', bigSpecimenSet: { __typename: 'CMS_SSR_BigSpecimenSet', lineHeight: number, letterSpacing: number, specimensPerFontStyle: number, referenceWordCalculatedWidth: number, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithWords', id: string, name: string, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, words: Array<{ __typename: 'CMS_SSR_SpecimenWord', width: number, content: string, contentAscii: string, opentypeFeatures: Array<string> | null }>, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type MediumSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type MediumSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', mediumSpecimenSet: { __typename: 'CMS_SSR_MediumSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, specimensPerFontStyle: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles', id: string, name: string, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, italicCssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, boldCssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type SmallSpecimenSetQueryVariables = Exact<{
  fontFamily: Scalars['ID'];
  contentAmount: Scalars['Int'];
}>;


export type SmallSpecimenSetQuery = { ssr: { __typename: 'CMS_SSR', smallSpecimenSet: { __typename: 'CMS_SSR_SmallSpecimenSet', fontSize: number, lineHeight: number, letterSpacing: number, columns: number, fixedOpentypeFeatures: Array<string> | null, randomOpentypeFeatures: Array<string> | null, randomOpentypeLikelihood: number, wordsInSmallCaps: number, lineCount: number, columnsSecondary: number, fontSizeSecondary: number, lineCountSecondary: number, sentences: Array<string>, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleWithCorrespondingStyles', pixelSize: number | null, id: string, name: string, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null }, italicCssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, boldCssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, variableAxes: Array<{ __typename: 'CMS_SSR_FontVariationAxisInterface', name: string, tag: string, defaultValue: number, minValue: number, maxValue: number } | null> | null }> } | null } };

export type FontFamilyGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FontFamilyGroupsQuery = { ssr: { __typename: 'CMS_SSR', fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, informationIntro: string | null, isCollection: boolean, name: string, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontStyleCount: number, fontSizeMultiplier: number, slug: string, unitPrice: number, svgHeading: string | null, seoTitle: string, seoDescription: string, seoImage: string, pdfSpecimen: string | null, typographicRanking: number | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, campaign: { __typename: 'CMS_SSR_CampaignInterface', type: CMS_SSR_CampaignsCampaignTypeChoices, displayMode: CMS_SSR_CampaignsCampaignDisplayModeChoices, transitionDuration: number, transitionInterval: number, svgHeadingOverlay: boolean, images: Array<{ __typename: 'CMS_SSR_CampaignImageInterface', id: string, sortOrder: number, imageLandscape: string, imageLandscapeWidth: number, imageLandscapeHeight: number, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, imagePortrait: string | null, imagePortraitWidth: number | null, imagePortraitHeight: number | null, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, colorBackground: string | null }>, videos: Array<{ __typename: 'CMS_SSR_CampaignVideoInterface', id: string, layoutModeLandscape: CMS_SSR_CampaignLayoutMode, marginOverlapLandscape: number, layoutModePortrait: CMS_SSR_CampaignLayoutMode, marginOverlapPortrait: number, videoLandscape: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> }, videoPortrait: { __typename: 'CMS_SSR_VimeoVideoInterface', id: string, title: string, width: number, height: number, files: Array<{ __typename: 'CMS_SSR_VimeoVideoFileInterface', id: string, width: number, height: number, type: string, src: string }> } | null }>, codes: Array<{ __typename: 'CMS_SSR_CampaignCodeInterface', id: string, animation: CMS_SSR_CampaignsCampaignCodeAnimationChoices, options: any }> } | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', classification: Array<string>, creditDesign: Array<string>, creditEngineering: Array<string>, creditCollaborators: Array<string>, fontStyleCount: number, id: string, name: string, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, isPreRelease: boolean, slug: string, seoImage: string, release: any | null, unitPrice: number, typographicRanking: number | null, hasVariableFonts: boolean, versionNumber: number | null, glyphCountPerRomanStyle: number, glyphCountPerItalicStyle: number, glyphCountTotal: number, kerningPairCountPerStyle: number, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, supportedLanguages: Array<{ __typename: 'CMS_SSR_LanguageInterface', id: string }>, vfRomanFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, vfItalicFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null, mainFontStyle: { __typename: 'CMS_SSR_FontStyleInterface', id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null, hasSafariSpaceSubBug: boolean }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null }, fontStyles: Array<{ __typename: 'CMS_SSR_FontStyleInterface', fontFamilySlug: string, id: string, name: string, weight: number, pointSize: number | null, pixelSize: number | null, unitPrice: number, fontProductType: CMS_SSR_FontProductTypeChoice, productName: string, productSubtitle: string, fontSizeMultiplier: number, typographicRanking: number | null, openTypeFeatures: Array<{ __typename: 'CMS_SSR_FontOpenTypeFeatureInterface', tag: string, label: string | null, hasSafariSpaceSubBug: boolean }>, ttfFiles: { __typename: 'CMS_SSR_FontFilesInterface', woff2FileSize: number | null } | null, fontStyleIdsByFamilyId: Array<{ __typename: 'CMS_SSR_ProductFontIds', fontFamilyId: string, fontStyleIds: Array<string> }>, fontSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null, cssRenderInfo: { __typename: 'CMS_SSR_CssRenderInfo', fontFamilyName: string, isItalic: boolean, woff2Path: string, fontWeight: number | null, variableAxisValues: Array<{ __typename: 'CMS_SSR_FontVariationInstanceAxisValueInterface', tag: string, value: number }> | null } | null, renderFontMetrics: { __typename: 'CMS_SSR_FontMetricsInterface', unitsPerEmHead: number, capHeightCalc: number, xHeightOs2: number, ascentCalc: number, ascentHhea: number, descentCalc: number, descentHhea: number, lineGapHhea: number } | null }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }>, subfamilies: Array<{ __typename: 'CMS_SSR_FontSubfamilyInterface', name: string }>, mainSubfamily: { __typename: 'CMS_SSR_FontSubfamilyInterface', name: string } | null }> }> } };

export type InUsePostPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type InUsePostPagesQuery = { ssr: { __typename: 'CMS_SSR', inUsePosts: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPage', slug: string, title: string, seoTitle: string, noindex: boolean, mediaCount: number, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, placeholderColor: string | null, hasAlpha: boolean | null }, feedImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null, designerLinks: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink', name: string | null, url: string | null } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, body: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock', singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, name: string, slug: string, isPreRelease: boolean, typographicRanking: number | null, fontFamilyGroup: { __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, slug: string, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }> } }> | null, categories: Array<{ __typename: 'CMS_SSR_FontsInUseDetailPageMediaTag', name: string | null, slug: string | null, id: string | null }> | null }> | null } };

export type InUseDesignerLinkFragment = { __typename: 'CMS_SSR_DesignerLink', name: string | null, url: string | null };

export type InUseSimpleVideoBlockFragment = { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null };

export type InUseSimpleImageBlockFragment = { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type InUseSimpleImageSectionBlockFragment = { __typename: 'CMS_SSR_SimpleImageSectionBlock', singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock', image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock', video: string, videoAspectRatio: string | null } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null };

export type CustomFontsPostPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomFontsPostPagesQuery = { ssr: { __typename: 'CMS_SSR', customFonts: Array<{ __typename: 'CMS_SSR_CustomFontInterface', id: string, name: string, slug: string | null, svgHeading: string | null, bitmapHeading: string | null, informationIntro: string | null, creditDesign: Array<string>, creditClient: Array<string>, creditAgency: Array<string>, creditCollaborators: Array<string>, seoTitle: string, seoImage: string, seoDescription: string, backgroundColor: string, foregroundColor: string, highlightColor: string, styles: Array<{ __typename: 'CMS_SSR_CustomFontStyleInterface', id: string, name: string, svg: string, weight: number, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, name: string, sortOrder: number } | null }>, families: Array<{ __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, svg: string | null, sortOrder: number }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, specimens: Array<{ __typename: 'CMS_SSR_CustomFontSpecimenInterface', id: string, name: string, sortOrder: number, svg: string | null, bitmap: string | null, family: { __typename: 'CMS_SSR_CustomFontFamilyInterface', id: string, name: string, sortOrder: number } | null }>, images: Array<{ __typename: 'CMS_SSR_CustomFontImageInterface', id: string, image: string, feature: boolean, sortOrder: number }>, awards: Array<{ __typename: 'CMS_SSR_AwardInterface', id: string, year: number, name: string, sortOrder: number }> }> } };

export type InUseCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type InUseCategoriesQuery = { ssr: { __typename: 'CMS_SSR', inUseCategories: Array<{ __typename: 'CMS_SSR_TagInterface', slug: string, name: string }> } };

export type BlogPostStubsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPostStubsQuery = { ssr: { __typename: 'CMS_SSR', blogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null }> | null } };

export type BlogPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogPostsQuery = { ssr: { __typename: 'CMS_SSR', blogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', id: string | null, noindex: boolean, title: string, seoTitle: string, searchDescription: string | null, blurb: string | null, slug: string, postDate: any, intro: string | null, author: string | null, lastPublishedAt: any | null, expireAt: any | null, highlightColor: string, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, feedImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, body: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock', footNotes: string | null, textContent: string } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock', title: string } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock', heading: string | null, singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, colorText: string | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock', question: string, answer: string } | { __typename: 'CMS_SSR_QuoteBlock', quote: string, caption: string | null } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock', video: string, caption: string | null, videoAspectRatio: string | null, thumbnailUrl: string | null, accessibilityTitle: string | null, posterImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null } | null> | null, hero: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock' } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock', field: string, landscapeImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number } | null, landscapeSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null, portraitImage: { __typename: 'CMS_SSR_CustomImage', file: string, height: number, width: number } | null, portraitSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock' } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string, name: string, slug: string, svgNavigation: string | null, informationIntro: string | null, isCollection: boolean, typographicRanking: number | null, colorSchemes: Array<{ __typename: 'CMS_SSR_ColorSchemeInterface', backgroundColor: string, foregroundColor: string, highlightColor: string, backgroundColorAlt: string | null, foregroundColorAlt: string | null, highlightColorAlt: string | null }>, designInformationPage: { __typename: 'CMS_SSR_BlogPage', slug: string } | null, fontFamilies: Array<{ __typename: 'CMS_SSR_FontFamilyInterface', id: string, slug: string, name: string, isPreRelease: boolean, fontStyleCount: number, typographicRanking: number | null }> }> | null, relatedBlogPosts: Array<{ __typename: 'CMS_SSR_BlogPage', noindex: boolean, blurb: string | null, id: string | null, title: string, seoTitle: string, slug: string, postDate: any, blurbImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number, placeholderColor: string | null, hasAlpha: boolean | null }, categories: Array<{ __typename: 'CMS_SSR_BlogTag', id: string | null, name: string | null, slug: string | null }>, fontFamilyGroups: Array<{ __typename: 'CMS_SSR_FontFamilyGroupInterface', id: string }> | null }> }> | null } };

export type BlogContentWithFootNotesBlockFragment = { __typename: 'CMS_SSR_ContentWithFootNotesBlock', footNotes: string | null, textContent: string };

export type BlogVideoBlockFragment = { __typename: 'CMS_SSR_VideoBlock', video: string, caption: string | null, videoAspectRatio: string | null, thumbnailUrl: string | null, accessibilityTitle: string | null, posterImage: { __typename: 'CMS_SSR_CustomImage', file: string } | null };

export type BlogHeadingBlockFragment = { __typename: 'CMS_SSR_HeadingBlock', title: string };

export type BlogSimpleVideoCaptionBlockFragment = { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null };

export type BlogImageBlockFragment = { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type BlogImageSectionBlockFragment = { __typename: 'CMS_SSR_ImageSectionBlock', heading: string | null, singleImageLayout: CMS_SSR_SingleImageLayoutChoice, colorBackground: string | null, noVerticalMargins: boolean | null, colorText: string | null, showBackground: boolean | null, content: Array<{ __typename: 'CMS_SSR_BlockQuoteBlock' } | { __typename: 'CMS_SSR_BooleanBlock' } | { __typename: 'CMS_SSR_CharBlock' } | { __typename: 'CMS_SSR_ChoiceBlock' } | { __typename: 'CMS_SSR_ContentWithFootNotesBlock' } | { __typename: 'CMS_SSR_DateBlock' } | { __typename: 'CMS_SSR_DateTimeBlock' } | { __typename: 'CMS_SSR_DecimalBlock' } | { __typename: 'CMS_SSR_DesignerLink' } | { __typename: 'CMS_SSR_DocumentChooserBlock' } | { __typename: 'CMS_SSR_EmailBlock' } | { __typename: 'CMS_SSR_EmbedBlock' } | { __typename: 'CMS_SSR_FeaturedImageLinkBlock' } | { __typename: 'CMS_SSR_FloatBlock' } | { __typename: 'CMS_SSR_HeadingBlock' } | { __typename: 'CMS_SSR_HeroVideoAndImageBlocks' } | { __typename: 'CMS_SSR_HomepageCampaignBlock' } | { __typename: 'CMS_SSR_HyperlinkedBaseBlock' } | { __typename: 'CMS_SSR_ImageBlock', caption: string | null, image: { __typename: 'CMS_SSR_CustomImage', width: number, height: number, id: string | null, title: string, file: string, placeholderColor: string | null, hasAlpha: boolean | null } | null, svg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null } | { __typename: 'CMS_SSR_ImageChooserBlock' } | { __typename: 'CMS_SSR_ImageSectionBlock' } | { __typename: 'CMS_SSR_ImageWithPortraitBlock' } | { __typename: 'CMS_SSR_IntegerBlock' } | { __typename: 'CMS_SSR_ListBlock' } | { __typename: 'CMS_SSR_PageChooserBlock' } | { __typename: 'CMS_SSR_QuestionAndAnswerBlock' } | { __typename: 'CMS_SSR_QuoteBlock' } | { __typename: 'CMS_SSR_RawHTMLBlock' } | { __typename: 'CMS_SSR_RegexBlock' } | { __typename: 'CMS_SSR_RichTextBlock' } | { __typename: 'CMS_SSR_SimpleHyperlinkedImageBlock' } | { __typename: 'CMS_SSR_SimpleImageBlock' } | { __typename: 'CMS_SSR_SimpleImageSectionBlock' } | { __typename: 'CMS_SSR_SimpleVideoBlock' } | { __typename: 'CMS_SSR_SimpleVideoCaptionBlock', video: string, videoAspectRatio: string | null, caption: string | null } | { __typename: 'CMS_SSR_SnippetChooserBlock' } | { __typename: 'CMS_SSR_StaticBlock' } | { __typename: 'CMS_SSR_StreamBlock' } | { __typename: 'CMS_SSR_StreamFieldBlock' } | { __typename: 'CMS_SSR_StructBlock' } | { __typename: 'CMS_SSR_TextBlock' } | { __typename: 'CMS_SSR_TimeBlock' } | { __typename: 'CMS_SSR_URLBlock' } | { __typename: 'CMS_SSR_VideoBlock' } | null> | null };

export type BlogQuoteBlockFragment = { __typename: 'CMS_SSR_QuoteBlock', quote: string, caption: string | null };

export type BlogQuestionAndAnswerBlockFragment = { __typename: 'CMS_SSR_QuestionAndAnswerBlock', question: string, answer: string };

export type BlogHeroImageFragment = { __typename: 'CMS_SSR_ImageWithPortraitBlock', field: string, landscapeImage: { __typename: 'CMS_SSR_CustomImage', file: string, width: number, height: number } | null, landscapeSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null, portraitImage: { __typename: 'CMS_SSR_CustomImage', file: string, height: number, width: number } | null, portraitSvg: { __typename: 'CMS_SSR_DocumentObjectType', file: string } | null };

export type BlogCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BlogCategoriesQuery = { ssr: { __typename: 'CMS_SSR', blogCategories: Array<{ __typename: 'CMS_SSR_BlogTagInterface', id: string, name: string, slug: string }> } };
